import React, { useRef, useState } from 'react';
import styles from './NewPage.module.css';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import { AiOutlinePlus } from 'react-icons/ai';
import floopyDisk from 'assets/floopyDisk.png';
import Overview from './Overview';
import LiveData from './LiveData';
import Day1 from './Day1';
import Channels from './Channels';
import ContextMenu from './ContextMenu';
import { useEffect } from 'react';
import ToolBar from './ToolBar';
import Draggble from 'react-draggable';
import { addWidget } from '../../../../../redux/slices/viewDataSlice.js';
import { useDispatch } from 'react-redux';
import { useToast } from '@chakra-ui/react';
import {
  TempGenerateDevice,
  TempGenerateDisplay,
  TempGenerateIO,
  TempGenerateController,
  TempGenerateFlowMeter,
  TempGenerateEnergyNeter,
  TempGenerateMotor,
  TempGenerateText,
  TempGenerateLineChart,
  TempGeneratePieChart,
  TempGenerateBarChart,
  TempGenerateHistogram,
  TempGenerateGauge,
  TempGenerateProgressBar,
  TempGenerateGrid,
  TempGenerateTable,
  TempGenerateCircularProgress,
  TempGenerateDoughnutChart,
  TempGenerateLines,
  TempGenerateSquare,
  TempGenerateCircle,
  TempGeneratePolygone,
  TempGeneratePipe,
  TempGenerateSwitch,
  TempGenerateCheckbox,
  TempGenerateRadio,
  TempGenerateSlider,
  TempGenerateLamp,
  TempGeneratePush,
  TempGenerateLink,
  TempGenerateClock,
} from './NewPage/widgetGenerateFunctions';

import {
  GenerateNewDisplay,
  GenerateNewIndicatores,
  GenerateNewController,
  GenerateNewIO,
  GenerateNewFlowMeter,
  GenerateNewEnergyMeter,
  GenerateNewText,
  GenerateNewMotor,
  GenerateNewLineChart,
  GenerateNewPieChart,
  GenerateNewBarChart,
  GenerateNewHistogram,
  GenerateNewGauge,
  GenerateNewProgressbar,
  GenarateNewTable,
  GenerateNewGrid,
  GenerateNewCircularProgress,
  GenerateNewDoughnutChart,
  GenerateNewLines,
  GenerateNewSquare,
  GenerateNewCircle,
  GenerateNewPolygon,
  GenerateNewPipe,
  GenerateNewSwitch,
  GenerateNewCheckbox,
  GenerateNewRadio,
  GenerateNewSlider,
  GenerateNewLamp,
  GenerateNewPush,
  GenerateNewLink,
  GenerateNewClock,
} from './NewPage/NewWidgetGenerateFunctions';

import { WidgetSelectChannel } from './NewPage/WidgetSelectChannelFunction';
import { WidgetRename } from './NewPage/WidgetRenameFunction';
import {
  DeleteSavedWidgets,
  DeleteNewWidgets,
} from './NewPage/WidgetDeleteFunction';
import { SaveView } from './NewPage/SaveViewFunction';
import {
  getDimensions,
  handleDragStop,
  handleNewDeleteImage,
  handleSavedDeleteImage,
  TempGetDimensions,
  TempHandleDragStop,
} from './NewPage/ImageFuctions';

import { handleChangeSV } from './NewPage/WidgetDoubleClickFunction';

import {
  handleRangeSave,
  handleRotateBar,
  handleSaveCheckBox,
  handleSaveTimePeriod,
  handleChangeFormat,
  handleChangeBg,
  handleIOText,
  handleIOColor,
} from './NewPage/ExtraFunctions';

import PolygonDrawer from './PolygoneDrawer';
import PipeDrawer from './NewPage/components/PipeDrawer';
import Konva from 'konva';
import { BlinkPopup, ChangeIOColor, ChangeIOText, ChangeSVModal, ChannelCheckboxModal, ChannelsModal, GraphInterval, HidePopup, LineStyle, PropertiesModal, RangeModal, RenameModal, SetLimit, ShowHorizontalMovementPopup, ShowVerticalMovementPopup, TimePeriodModal, YAxisRange } from './NewPage/components/Popups';
import { WidgetZIndexChange } from './NewPage/WidgetPositionFunction';

const NewPage = ({
  documentId,
  setOpenNewPage,
  data,
  uniqueProjectId,
  socketData,
  tabNames,
  images,
  setImages,
  setTempImagePosition,
  tabIndexImages,
  setTabIndexImages,
  tableData,
  apiChannels,
  tabIndexDevices,
  setTabIndexDevices,
  openNewPage,
  tabIndexController,
  setTabIndexController,
  setTabIndexIO,
  tabIndexIO,
  setTabIndexFlowM,
  tabIndexFlowM,
  tabIndexEnergyM,
  setTabIndexEnergyM,
  tabIndexLineChart,
  setTabIndexLineChart,
  setTabIndexPieChart,
  tabIndexPieChart,
  dateTimesLive,
  channelNames,
  dataArrLive,
  getRandomColor,
  tabIndexBarChart,
  setTabIndexBarChart,
  barChartData,
  setBarChartData,
  tabIndexHistogram,
  setTabIndexHistogram,
  histogramData,
  setHistogramData,
  tabIndexGauge,
  setTabIndexGauge,
  tabIndexProgress,
  setTabIndexProgress,
  windowHeight,
  windowWidth,
  tabIndexGrid,
  setTabIndexGrid,
  oneDayDataTs,
  tabIndexTable,
  setTabIndexTable,
  tabIndexOverviewInfo,
  tabIndexOverviewGraph,
  setTabIndexOverviewInfo,
  setTabIndexOverviewGraph,
  setTabIndexLiveDataGraph,
  tabIndexLiveDataGraph,
  tabIndexLastDayTable,
  setTabIndexLastDayTable,
  tabIndexLastDayGraph,
  setTabIndexLastDayGraph,
  tabIndexDefaultGrid,
  setTabIndexDefaultGrid,
  selectedTabIndex,
  setSelectedTabIndex,
  tempTabIndexLiveDataGraph,
  tempTabIndexOverviewInfo,
  tempTabIndexOverviewGraph,
  tempTabIndexLastDayTable,
  tempTabIndexLastDayGraph,
  tempTabIndexDefaultGrid,
  scaleValue,
  tabIndexMotor,
  setTabIndexMotor,
  tabIndexDisplay,
  setTabIndexDisplay,
  tabIndexText,
  setTabIndexText,
  vNetPassword,
  vNetUsername,
  deviceName,
  deviceGroupName,
  tagGroupName,
  tabIndexCircularProgress,
  setTabIndexCircularProgress,
  tabIndexDoughnut,
  setTabIndexDoughnut,
  tabIndexLines,
  setTabIndexLines,
  setTabIndexSquare,
  tabIndexSquare,
  tabIndexCircle,
  setTabIndexCircle,
  tabIndexPolygone,
  setTabIndexPolygone,
  tabIndexPipe,
  setTabIndexPipe,
  setTabIndexSwitch,
  tabIndexSwitch,
  setTabIndexCheckbox,
  tabIndexCheckbox,
  tabIndexRadio,
  setTabIndexRadio,
  tabIndexSlider,
  setTabIndexSlider,
  tabIndexLamp,
  setTabIndexLamp,
  tabIndexPush,
  setTabIndexPush,
  tabIndexList,
  setTabIndexList,
  tabIndexLink,
  setTabIndexLink,
  tabIndexClock,
  setTabIndexClock,
  widgetData,
}) => {
  // Images and Tabs State
  const [isPath, setIsPath] = useState('Overview');
  const [addNewTag, setAddNewTag] = useState(false); // To Handle Opening and Closing Of Add Tab Name Modal
  const [tabNameInput, setTabNameInput] = useState('');
  const [inputValues, setInputValues] = useState(tabNames); // Input Values for Add New Tab Modal
  const [RenameInputValues, setRenameInputValues] = useState([]);
  const [deletedTabs, setDeletedTabs] = useState([]);
  const [openContextMenu, setOpenContextMenu] = useState(false); // To Handle Opening and Closing Of Context Menu
  const [contextMenuPosition, setContextMenuPosition] = useState({
    x: 0,
    y: 0,
  }); // Position of Context Menu
  const [isRenameModel, setIsRenameModel] = useState(false); //To Handle Opening and Closing Of Rename Tab Modal
  const [clickedTabIndex, setClickedTabIndex] = useState(null); // Index of Tab
  const [selectedTab, setSelectedTab] = useState(''); // selected Tab Name
  const [tempTabNames, setTempTabNames] = useState(tabNames); // copy of tabNames
  const [tempImages, setTempImages] = useState([...images]); // copy of all data
  const [tempTabIndexImages, setTempTabIndexImages] = useState(tabIndexImages); // copy of tabIndexImages
  const [multipleImages, setMultipleImages] = useState([]); // to store new  images
  const [indexesToRaname, setIndexesToRename] = useState([]);
  const [displayImage, setDisplayImage] = useState();
  const [imagePosition, setImagePosition] = useState([]); // new images position
  const [imageDimensions, setImageDimensions] = useState([]); // new images width, height
  const [deleteContextMenu, setDeleteContextMenu] = useState(false); // to open delete context menu
  const [deleteContextPosi, setDeleteContextPosi] = useState({ x: 0, y: 0 }); // position of context menu
  const [clickedImgIndex, setClickedImgIndex] = useState(null);
  const [indexesToDeleteImg, setIndexesToDeleteImg] = useState([]);
  const [selectedImg, setSelectedImg] = useState();
  const [imagesToUpdate, setImagesToUpdate] = useState([]);
  const [storeTabIndexes, setStoreTabIndexes] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(selectedTabIndex); // current active tab index

  // Devices States

  const [tempTabIndexDevices, setTempTabIndexDevices] = useState(
    Object.assign({}, tabIndexDevices),
  ); // Indicators for this page
  const [tempTabIndexController, setTempTabIndexController] = useState(
    Object.assign({}, tabIndexController),
  ); // Comtrollers for this page
  const [deviceMenuPosition, setDeviceMenuPosition] = useState({ x: 0, y: 0 }); // Position of context menu
  const [isDeviceMenu, setIsDeviceMenu] = useState(false);
  const [multipleDevices, setMultipleDevices] = useState([
    { deviceName: '', type: '' },
  ]); // New indicators
  const [devicePosition, setDevicePosition] = useState([]); // New indicators position
  const [isChannels, setIsChannels] = useState(false);
  const [renameDeviceModal, setRenameDeviceModal] = useState(false);
  const [devicesName, setDevicesName] = useState([]);
  const [indexesDeviceName, setIndexesDeviceName] = useState([]);
  const [clickedDeviceIndex, setClickedDeviceIndex] = useState(); // particular device index
  const [tabIndexForDevice, setTabIndexForDevices] = useState([]); // tab index to add any new device
  const [selectedDevice, setSelectedDevice] = useState(); // paticular device that's been right clciked
  const [pvSpecificChannel, setPVSpecificChannel] = useState([]);
  const [indexesOfDevicePosi, setIndexesOfDevicePosi] = useState([]);
  const [currentPVChannel, setCurrentPVChannel] = useState('');
  const [currentPVController, setCurrentPVController] = useState('');
  const [currentSVContoller, setCurrentSVController] = useState('');
  const [currentPVEnergyM, setCurrentPVEnergyM] = useState('');
  const [currentSVEnergyM, setCurrentSVEnergyM] = useState('');
  const [currentPVFlowM, setCurrentPVFlowM] = useState('');
  const [currentSVFlowM, setCurrentSVFlowM] = useState('');
  const [pvControllerChannel, setPVControllerChannel] = useState([]); // pv channels for controller
  const [svControllerChannel, setSVControllerChannel] = useState([]); // sv channels for controller
  const [currentDevice, setCurrentDevice] = useState('');
  const [multipleController, setMultipleController] = useState([
    { deviceName: '', type: '' },
  ]); // to store new controllers

  const [controllerPosition, setControllerPosition] = useState([]); // new controllers position
  const [multipleIO, setMultipleIO] = useState([{ deviceName: '', type: '' }]); //  to store new IO
  const [tempTabIndexIO, setTempTabIndexIO] = useState(
    Object.assign({}, tabIndexIO),
  ); // copy of tabIndexIO
  const [ioPosition, setIOPosition] = useState([]); // new IO position
  const [multipleFlowM, setMultipleFlowM] = useState([
    { deviceName: '', type: '' },
  ]); // to store new flow meter
  const [tempTabIndexFlowM, setTempTabIndexFlowM] = useState(
    Object.assign({}, tabIndexFlowM),
  ); // copy of tabIndexFlowM
  const [flowMPosition, setFlowMPosition] = useState([]); // new flow meters posiiton
  const [pvFlowMChannels, setPVFlowMChannels] = useState([]); // pv channels for flow meter
  const [svFlowMChannels, setSVFlowMChannels] = useState([]); // sv channels for flow meter

  const [multipleEnergyM, setMultipleEnergyM] = useState([
    { deviceName: '', type: '' },
  ]); // to store new energy meter
  const [tempTabIndexEnergyM, setTempTabIndexEnergyM] = useState(
    Object.assign({}, tabIndexEnergyM),
  ); // copy of tabIndexEnergyM
  const [energyMPosition, setEnergyMPosition] = useState([]); // new energy meter position
  const [pvEnergyMChannels, setPVEnergyMChannels] = useState([]); // pv channels for energy meter
  const [svEnergyMChannels, setSVEnergyMChannels] = useState([]); // sv channels for energy meter

  // Charts states
  const [multipleLineCharts, setMultipleLineCharts] = useState([
    { deviceName: '', type: '' },
  ]); //to store new line charts
  const [lineChartPosition, setLineChartPosition] = useState([]); // new line charts position
  const [tempTabIndexLineChart, setTempTabIndexLineChart] = useState(
    Object.assign({}, tabIndexLineChart),
  ); // copy of tabIndexLineChart

  const [multiplePieChart, setMultiplePieChart] = useState([
    { deviceName: '', type: '', x: 0, y: 0 },
  ]); //to store new pie charts
  const [tempTabIndexPieChart, setTempTabIndexPieChart] = useState(
    Object.assign({}, tabIndexPieChart),
  ); // copy of tabIndexPieChart
  const [pieChartPosition, setPieChartPosition] = useState([]); // new pie charts position
  const [pieChartChannels, setPieChartChannels] = useState([]); // channels for pie charts
  const [lineChartChannels, setLineChartChannels] = useState([]); // channels for line charts

  const [plusIcon, setPlusIcon] = useState(false);
  const [displaySelectTag, setDisplaySelectTag] = useState([]);

  const [multipleBarChart, setMultipleBarChart] = useState([
    { deviceName: '', type: '' },
  ]); // to store new bar charts
  const [tempTabIndexBarChart, setTempTabIndexBarChart] = useState(
    Object.assign({}, tabIndexBarChart),
  ); // copy of tabIndexBarChart
  const [barChartChannels, setBarChartChannels] = useState([]); // channels for bar charts
  const [barChartPosition, setBarChartPosition] = useState([]); // new bar charts position

  const [multipleHistogram, setMultipleHistogram] = useState([
    { deviceName: '', type: '' },
  ]); // to store new histogram
  const [histogramPosition, setHistogramPosition] = useState([]); // new histogram position
  const [tempTabIndexHistogram, setTempTabIndexHistogram] = useState(
    Object.assign({}, tabIndexHistogram),
  ); // copy of tabIndexHistogram
  const [histogramChannels, setHistogramChannels] = useState([]); // channels for histogram
  const [multipleGauge, setMultipleGauge] = useState([
    { deviceName: '', type: '' },
  ]);
  const [tempTabIndexGauge, setTempTabIndexGauge] = useState(
    Object.assign({}, tabIndexGauge),
  ); // Gauges for this page
  const [gaugePosition, setGaugePosition] = useState([]); // To track gauge position
  const [gaugeChannels, setGaugeChannels] = useState([]); // To store gauge channels
  const [isRangeModel, setIsRangeModal] = useState(false); //Handle Range model
  const [startPoint, setStartPoint] = useState([]);
  const [endPoint, setEndPoint] = useState([]);
  const [multipleProgress, setMultipleProgress] = useState([
    { deviceName: '', type: '' },
  ]); // To store new progressbar
  const [tempTabIndexProgress, setTempTabIndexProgress] = useState(
    Object.assign({}, tabIndexProgress),
  ); // Progressbar for this page
  const [progressPosition, setProgressPosition] = useState([]);
  const [progressChannels, setProgressChannels] = useState([]);
  const [maximumVal, setMaximumVal] = useState([]);
  const [minimumVal, setMinimumVal] = useState([]);
  const [rotateBar, setRotateBar] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [changeRange, setChangeRange] = useState(false);
  const [specificMinVal, setSpecificMinVal] = useState();
  const [specificMaxVal, setSpecificMaxVal] = useState();

  const [multipleGrid, setMultipleGrid] = useState([
    { deviceName: '', type: '' },
  ]); // Grid for this page
  const [tempTabIndexGrid, setTempTabIndexGrid] = useState(
    Object.assign({}, tabIndexGrid),
  ); // copy of tabIndexHistogram

  const [gridChannels, setGridChannels] = useState([]);
  const [gridPositions, setGridPosition] = useState([]);
  const [isChannelCheckBox, setIsChannelCheckBox] = useState(false);
  const [selectAllCheck, setSelectAllCheck] = useState(false);
  const [isTimePeriod, setIsTimePeriod] = useState(false);
  const [endSelect, setEndSelect] = useState('Hours');
  const [endDays, setEndDays] = useState(0);
  const [endHours, setEndHours] = useState(0);
  const [endMinutes, setEndMinutes] = useState(0);
  const [multipleTable, setMultipleTable] = useState([
    { deviceName: '', type: '' },
  ]);

  const [tempTabIndexTable, setTempTabIndexTable] = useState(
    Object.assign({}, tabIndexTable),
  );
  const [tablePosition, setTablePosition] = useState([]);
  const [tableChannels, setTableChannels] = useState([]);
  const [tableFormat, setTableFormat] = useState(false);
  const [overviewInfoPosi, setOverviewInfoPosi] = useState();

  const [overviewGraphPosi, setOverviewGraphPosi] = useState();
  const [overviewGraphDimension, setOverviewGraphDimension] = useState();
  const [liveDataGraphPosi, setLiveDataGraphPosi] = useState();
  const [liveDataGraphDimension, setLiveDataGraphDimension] = useState();
  const [lastDayTablePosi, setLastDayTablePosi] = useState();
  const [lastDayTableDimension, setLastDayTableDimension] = useState();
  const [lastDayGraphPosi, setLastDayGraphPosi] = useState();
  const [lastDayGraphDimension, setLastDayGraphDimension] = useState();
  const [defaultGridPosi, setDefaultGridPosi] = useState();
  const [defaultGridDimension, setDefaultGridDimension] = useState();
  const [selectedDeviceId, setSelectedDeviceId] = useState();

  // States to save data for updated widget

  const [updatedTabIndexImages, setUpdatedTabIndexImages] = useState(
    Object.assign({}, tabIndexImages),
  );

  const [updatedTabIndexDevices, setUpdatedTabIndexDevices] = useState(
    Object.assign({}, tabIndexDevices),
  );
  const [updatedTabIndexController, setUpdatedTabIndexController] = useState(
    Object.assign({}, tabIndexController),
  );
  const [updatedTabIndexIO, setUpdatedTabIndexIO] = useState(
    Object.assign({}, tabIndexIO),
  );
  const [updatedTabIndexFlowM, setUpdatedTabIndexFlowM] = useState(
    Object.assign({}, tabIndexFlowM),
  );
  const [updatedTabIndexEnergyM, setUpdatedTabIndexEnergyM] = useState(
    Object.assign({}, tabIndexEnergyM),
  );
  const [updatedTabIndexLineChart, setUpdatedTabIndexLineChart] = useState(
    Object.assign({}, tabIndexLineChart),
  );
  const [updatedTabIndexPieChart, setUpdatedTabIndexPieChart] = useState(
    Object.assign({}, tabIndexPieChart),
  );
  const [updatedTabIndexBarChart, setUpdatedTabIndexBarChart] = useState(
    Object.assign({}, tabIndexBarChart),
  );
  const [updatedTabIndexHistogram, setUpdatedTabIndexHistogram] = useState(
    Object.assign({}, tabIndexHistogram),
  );
  const [updatedTabIndexGauge, setUpdatedTabIndexGauge] = useState(
    Object.assign({}, tabIndexGauge),
  );
  const [updatedTabIndexProgress, setUpdatedTabIndexProgress] = useState(
    Object.assign({}, tabIndexProgress),
  );
  const [updatedTabIndexGrid, setUpdatedTabIndexGrid] = useState(
    Object.assign({}, tabIndexGrid),
  );
  const [updatedTabIndexTable, setUpdatedTabIndexTable] = useState(
    Object.assign({}, tabIndexTable),
  );

  const [updatedMultipleImages, setUpdatedMultipleImages] = useState([
    ...multipleImages,
  ]);

  const [updatedMultipleDevices, setUpdatedMultipleDevices] = useState([
    ...multipleDevices,
  ]);

  const [updatedMultipleController, setUpdatedMultipleController] = useState([
    ...multipleController,
  ]);

  const [updatedMultipleIO, setUpdatedMultipleIO] = useState([...multipleIO]);

  const [updatedMultipleFlowM, setUpdatedMultipleFlowM] = useState([
    ...multipleFlowM,
  ]);
  const [updatedMultipleEnergyM, setUpdatedMultipleEnergyM] = useState([
    ...multipleEnergyM,
  ]);
  const [updatedMultipleLineChart, setUpdatedMultipleLineChart] = useState([
    ...multipleLineCharts,
  ]);
  const [updatedMultiplePieChart, setUpdatedMultiplePieChart] = useState([
    ...multiplePieChart,
  ]);
  const [updatedMultipleBarChart, setUpdatedMultipleBarChart] = useState([
    ...multipleBarChart,
  ]);
  const [updatedMultipleHistogram, setUpdatedMultipleHistogram] = useState([
    ...multipleHistogram,
  ]);
  const [updatedMultipleGauge, setUpdatedMultipleGauge] = useState([
    ...multipleGauge,
  ]);
  const [updatedMultipleProgress, setUpdatedMultipleProgress] = useState([
    ...multipleProgress,
  ]);
  const [updatedMultipleGrid, setUpdatedMultipleGrid] = useState([
    ...multipleGrid,
  ]);
  const [updatedMultipleTable, setUpdatedMultipleTable] = useState([
    ...multipleTable,
  ]);

  const [tempTabIndexMotor, setTempTabIndexMotor] = useState(
    Object.assign({}, tabIndexMotor),
  );
  const [updatedTabIndexMotor, setUpdatedTabIndexMotor] = useState(
    Object.assign({}, tabIndexMotor),
  );

  const [multipleMotor, setMultipleMotor] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultipleMotor, setUpdatedMultipleMotor] = useState([
    ...multipleMotor,
  ]);
  const [motorPosition, setMotorPosition] = useState([]);
  const [isMotorOptions, setIsMotorOptions] = useState(false);
  const [isDeviceOption, setIsDeviceOption] = useState(false);

  const [multipleDisplay, setMultipleDisplay] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultipleDisplay, setUpdatedMultipleDisplay] = useState([
    ...multipleDisplay,
  ]);

  const [tempTabIndexDisplay, setTempTabIndexDisplay] = useState(
    Object.assign({}, tabIndexDisplay),
  );

  const [updatedTabIndexDisplay, setUpdatedTabIndexDisplay] = useState(
    Object.assign({}, tabIndexDisplay),
  );

  const [displayPosition, setDisplayPosition] = useState([]);

  const [multipleText, setMultipleText] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultipleText, setUpdatedMultipleText] = useState([
    ...multipleText,
  ]);

  const [updatedTabIndexText, setUpdatedTabIndexText] = useState(
    Object.assign({}, tabIndexText),
  );

  const [tempTabIndexText, setTempTabIndexText] = useState(
    Object.assign({}, tabIndexText),
  );

  const [textPosition, setTextPosition] = useState([]);

  const [multipleCircularProgress, setMultipleCircularProgress] = useState([
    {
      deviceName: '',
      type: '',
    },
  ]);

  const [updatedMultipleCircularProgress, setUpdatedMultipleCircularProgress] =
    useState([...multipleCircularProgress]);


  const [updatedTabIndexCircularProgress, setUpdatedTabIndexCircularProgress] =
    useState(Object.assign({}, tabIndexCircularProgress));

  const [tempTabIndexCircularProgress, setTempTabIndexCircularProgress] =
    useState(Object.assign({}, tabIndexCircularProgress));


  const [circularProgressPosition, setCircularProgressPosition] = useState([]);

  const [multipleDoughnut, setMultipleDoughnut] = useState([
    {
      deviceName: '',
      type: '',
    },
  ]);
  const [updatedMultipleDoughnut, setUpdatedMultipleDoughnut] = useState([
    ...multipleDoughnut,
  ]);
  const [updatedTabIndexDoughnut, setUpdatedTabIndexDoughnut] = useState(
    Object.assign({}, tabIndexDoughnut),
  );
  const [tempTabIndexDoughnut, setTempTabIndexDoughnut] = useState(
    Object.assign({}, tabIndexDoughnut),
  );
  const [doughnutPosition, setDoughnutPosition] = useState([]);
  const [doughnutChannels, setDoughnutChannels] = useState([]);

  const [isDrawingObjects, setIsDrawingObjects] = useState(false);
  const [isDrawing, setIsDrawing] = useState(false);
  const [isStartedDrawing, setIsStartedDrawing] = useState(false);
  const [multipleLines, setMultipleLines] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultipleLines, setUpdatedMultipleLines] = useState([
    ...multipleLines,
  ]);
  const [updatedTabIndexLines, setUpdatedTabIndexLines] = useState(
    Object.assign({}, tabIndexLines),
  );
  const [tempTabIndexLines, setTempTabIndexLines] = useState(
    Object.assign({}, tabIndexLines),
  );

  const [lineStartPosition, setLineStartPosition] = useState({ x: 0, y: 0 });
  const [linePosition, setLinePosition] = useState([]);

  const lineCanvasRef = useRef(null);

  const [multipleSquare, setMultipleSquare] = useState([
    { deviceName: '', type: '' },
  ]);
  const [updatedMultipleSquare, setUpdatedMultipleSquare] = useState([
    ...multipleSquare,
  ]);
  const [updatedTabIndexSquare, setUpdatedTabIndexSquare] = useState(
    Object.assign({}, tabIndexSquare),
  );
  const [tempTabIndexSquare, setTempTabIndexSquare] = useState(
    Object.assign({}, tabIndexSquare),
  );
  const [squarePosition, setSquarePosition] = useState([]);

  const [multipleCircle, setMultipleCircle] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultipleCircle, setUpdatedMultipleCircle] = useState([
    ...multipleCircle,
  ]);

  const [updatedTabIndexCircle, setUpdatedTabIndexCircle] = useState(
    Object.assign({}, tabIndexCircle),
  );

  const [tempTabIndexCircle, setTempTabIndexCircle] = useState(
    Object.assign({}, tabIndexCircle),
  );

  const [circlePosition, setCirclePosition] = useState([]);

  const [multiplePolygone, setMultiplePolygone] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultiplePolygone, setUpdatedMultiplePolygone] = useState([
    { deviceName: '', type: '' },
  ]);

  const [tempTabIndexPolygone, setTempTabIndexPolygone] = useState(
    Object.assign({}, tabIndexPolygone),
  );

  const [updatedTabIndexPolygone, setUpdatedTabIndexPolygone] = useState(
    Object.assign({}, tabIndexPolygone),
  );

  const [polygonePosition, setPolygonePosition] = useState([]);
  const [isPolygoneStage, setIsPolygoneStage] = useState(false);
  const [isPolygoneComplete, setIsPolygoneComplete] = useState(false);
  const [points, setPoints] = useState([]);

  const [isPipeStage, setIsPipeStage] = useState(false);
  const [pipePosition, setPipePosition] = useState([]);

  const [multiplePipe, setMultiplePipe] = useState([
    { deviceName: '', type: '' },
  ]);
  const [updatedMultiplePipe, setUpdatedMultiplePipe] = useState([
    ...multiplePipe,
  ]);
  const [tempTabIndexPipe, setTempTabIndexPipe] = useState(
    Object.assign({}, tabIndexPipe),
  );
  const [updatedTabIndexPipe, setUpdatedTabIndexPipe] = useState(
    Object.assign({}, tabIndexPipe),
  );

  const [isBtnOptions, setIsBtnOptions] = useState(false);

  const [multipleSwitch, setMultipleSwitch] = useState([
    { deviceName: '', type: '' },
  ]);
  const [updatedMultipleSwitch, setUpdatedMultipleSwitch] = useState([
    ...multipleSwitch,
  ]);

  const [tempTabIndexSwitch, setTempTabIndexSwitch] = useState(
    Object.assign({}, tabIndexSwitch),
  );

  const [updatedTabIndexSwitch, setUpdatedTabIndexSwitch] = useState(
    Object.assign({}, tabIndexSwitch),
  );

  const [switchPosition, setSwitchPosition] = useState([]);

  const [multipleCheckbox, setMultipleCheckbox] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultipleCheckbox, setUpdatedMultipleCheckbox] = useState([
    ...multipleCheckbox,
  ]);

  const [tempTabIndexCheckbox, setTempTabIndexCheckbox] = useState(
    Object.assign({}, tabIndexCheckbox),
  );

  const [updatedTabIndexCheckbox, setUpdatedTabIndexCheckbox] = useState(
    Object.assign({}, tabIndexCheckbox),
  );

  const [checkboxPosition, setCheckboxPosition] = useState([]);

  const [multipleRadio, setMultipleRadio] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultipleRadio, setUpdatedMultipleRadio] = useState([
    ...multipleRadio,
  ]);

  const [tempTabIndexRadio, setTempTabIndexRadio] = useState(
    Object.assign({}, tabIndexRadio),
  );

  const [updatedTabIndexRadio, setUpdatedTabIndexRadio] = useState(
    Object.assign({}, tabIndexRadio),
  );

  const [radioPosition, setRadioPosition] = useState([]);

  const [multipleSlider, setMultipleSlider] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultipleSlider, setUpdatedMultipleSlider] = useState([
    ...multipleSlider,
  ]);

  const [tempTabIndexSlider, setTempTabIndexSlider] = useState(
    Object.assign({}, tabIndexSlider),
  );

  const [updatedTabIndexSlider, setUpdatedTabIndexSlider] = useState(
    Object.assign({}, tabIndexSlider),
  );

  const [sliderPosition, setSliderPosition] = useState([]);

  const [sliderChannels, setSliderChannels] = useState([]);


  const [multipleLamp, setMultipleLamp] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultipleLamp, setUpdatedMultipleLamp] = useState([
    ...multipleLamp,
  ]);

  const [tempTabIndexLamp, setTempTabIndexLamp] = useState(
    Object.assign({}, tabIndexLamp),
  );

  const [updatedTabIndexLamp, setUpdatedTabIndexLamp] = useState(
    Object.assign({}, tabIndexLamp),
  );

  const [lampPosition, setLampPosition] = useState([]);


  const [multiplePush, setMultiplePush] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultiplePush, setUpdatedMultiplePush] = useState([
    ...multiplePush,
  ]);

  const [tempTabIndexPush, setTempTabIndexPush] = useState(
    Object.assign({}, tabIndexPush),
  );

  const [updatedTabIndexPush, setUpdatedTabIndexPush] = useState(
    Object.assign({}, tabIndexPush),
  );

  const [pushPosition, setPushPosition] = useState([]);

  const [multipleLink, setMultipleLink] = useState([
    { deviceName: '', type: '' },
  ]);

  const [updatedMultipleLink, setUpdatedMultipleLink] = useState([
    ...multiplePush,
  ]);

  const [tempTabIndexLink, setTempTabIndexLink] = useState(
    Object.assign({}, tabIndexLink),
  );

  const [updatedTabIndexLink, setUpdatedTabIndexLink] = useState(
    Object.assign({}, tabIndexLink),
  );

  const [linkPosition, setLinkPosition] = useState([]);

  const [multipleClock, setMultipleClock] = useState([
    { deviceName: '', type: '' },
  ]);
  const [updatedMultipleClock, setUpdatedMultipleClock] = useState([
    ...multipleClock,
  ]);
  const [tempTabIndexClock, setTempTabIndexClock] = useState(
    Object.assign({}, tabIndexClock),
  );
  const [updatedTabIndexClock, setUpdatedTabIndexClock] = useState(
    Object.assign({}, tabIndexClock),
  );
  const [clockPosition, setClockPosition] = useState([]);

  const [isHidePopup, setIsHidePopup] = useState(false);


  const [isBgColor, setIsBgColor] = useState(false);
  const [bgColor, setBgColor] = useState('#542A2A');
  const [textColor, setTextColor] = useState('#D90211');
  const [fontSize, setFontSize] = useState(30);

  const [textBgColor, setTextBgColor] = useState('#ffffff');
  const [widgetTextColor, setWidgetTextColor] = useState('#000000');

  const [textFontSize, setTextFontSize] = useState(30);
  const [addedText, setAddedText] = useState('');
  const [textAlignVertically, setTextAlignVertically] = useState('start');
  const [textAlignHorizontally, setTextAlignHorizontally] = useState('start');
  const [loginSid, setLoginSid] = useState('');

  const [isGraphOptions, setIsGraphOptions] = useState(false);
  const [isChangeText, setIsChangeText] = useState(false);
  const [isChangeColor, setIsChangeColor] = useState(false);

  const [onText, setOnText] = useState('');
  const [offText, setOffText] = useState('');
  const [onColor, setOnColor] = useState("");
  const [offColor, setOffColor] = useState("");
  const [isSetLimit, setIsSetLimit] = useState(false);
  const [upperLimit, setUpperLimit] = useState('');
  const [lowerLimit, setLowerLimit] = useState('');
  const [hideChannel, setHideChannel] = useState('');
  const [hideValue, setHideValue] = useState('');

  const [isChangeSV, setIsChangeSV] = useState(false);
  const [updatedImages, setUpdatedImages] = useState([...images]);
  const [isHorizontalMove, setIsHorizontalMove] = useState(false);
  const [horizontalMoveChannel, setHorizontalMoveChannel] = useState('');
  const [conditionValue, setConditionValue] = useState({});
  const [moveValue, setMoveValue] = useState({});


  const [isVerticalMove, setIsVerticalMove] = useState(false);
  const [verticalMoveChannel, setVerticalMoveChannel] = useState('');
  const [subMenuPosi, setSubMenuPosi] = useState({ x: 0, y: 0 });
  const [isSubMenu, setIsSubMenu] = useState(false);

  const [isLineStyle, setIsLineStyle] = useState(false);
  const [lineStyle, setLineStyle] = useState("");
  const [isCurveLine, setIsCurveLine] = useState(false);
  const [isSteppedLine, setIsSteppedLine] = useState(false);
  const [isYRange, setIsYRange] = useState(false);
  const [yRange, setYRange] = useState({ min: 0, max: 100 });
  const [isGraphInterval, setIsGraphInterval] = useState(false);
  const [yInterval, setYInterval] = useState(0);
  const [xInterval, setXInterval] = useState();
  const [isBlinkPopup, setIsBlinkPopup] = useState(false);
  const [blinkChannel, setBlinkChannel] = useState('');
  const [blinkValue, setBlinkValue] = useState(0);
  const [blinkFrequency, setBlinkFrequency] = useState(1000);
  const [blinkFunction, setBlinkFunction] = useState('=');
  const [borderRadius, setBorderRadius] = useState(null);
  const [lampStatus, setLampStatus] = useState([{ id: Date.now(), conditionValue: "", color: "" }])
  const [isTransparent, setIsTransperant] = useState(false);
  const [containerDimensions, setContainerDimensions ] = useState({ width: null, height: null })

  const indicatorRefs = useRef([]);
  const displayRefs = useRef([]);
  const controllerRefs = useRef([]);
  const imagesRefs = useRef([]);
  const flowMRefs = useRef([]);
  const ioRefs = useRef([]);
  const energyMRefs = useRef([]);
  const motorRefs = useRef([]);
  const lineChartRefs = useRef([]);
  const pieChartRefs = useRef([]);
  const barChartRefs = useRef([]);
  const histogramRefs = useRef([]);
  const gaugeRefs = useRef([]);
  const progressBarRefs = useRef([]);
  const gridRefs = useRef([]);
  const tableRefs = useRef([]);
  const textRefs = useRef([]);
  const circularProgressRefs = useRef([]);
  const doughnutRefs = useRef([]);
  const lineRefs = useRef([]);
  const squareRefs = useRef([]);
  const circleRefs = useRef([]);
  const polygoneRefs = useRef([]);
  const pipeRefs = useRef([]);
  const switchRefs = useRef([]);
  const checkboxRefs = useRef([]);
  const radioRefs = useRef([]);
  const sliderRefs = useRef([]);
  const lampRefs = useRef([]);
  const pushRefs = useRef([]);
  const linkRefs = useRef([]);
  const clockRefs = useRef([]);

  const newControllerRefs = useRef([]);

  const toast = useToast();
  const dispatch = useDispatch();

  let widgetsData = [];
  let deviceData = [];
  let displayData = [];
  let controllerData = [];
  let ioData = [];
  let flowMeterData = [];
  let energyMeterData = [];
  let lineChartData = [];
  let pieChartData = [];
  let toolbarChartData = [];
  let toolBarhistogramData = [];
  let gaugeData = [];
  let progressBarData = [];
  let gridData = [];
  let toolBarTableData = [];
  let overviewInfoData = [];
  let overviewGraphData = [];
  let liveGraphData = [];
  let lastDayTableData = [];
  let lastDayGraphData = [];
  let defaultGridData = [];
  let motorData = [];
  let textData = [];
  let circularProgressData = [];
  let doughnutData = [];
  let linesData = [];
  let squareData = [];
  let circleData = [];
  let polygoneData = [];
  let pipeData = [];
  let switchData = [];
  let checkboxData = [];
  let radioData = [];
  let sliderData = [];
  let lampData = [];
  let pushData = [];
  let linkData = [];
  let clockData = [];

  const comid = '100';
  const compvtkey = '8919244ff15d441bae4b944b112a33ea';
  const key = 'f1cd9351930d4e589922edbcf3b09a7c';

  const [dashOffset, setDashOffset] = useState(0);


  const layerRef = useRef(null);
  const animationRef = useRef([]); // keep refs for multiple pipes
  const parentDivRef = useRef(null);


  useEffect(() => {
    const parentWidth = parentDivRef.current.getBoundingClientRect().width;
    const parentHeight = parentDivRef.current.getBoundingClientRect().height;
    setContainerDimensions({width : parentWidth , height : parentHeight})

  }, [])


  useEffect(() => {
    const layer = layerRef.current;

    const anim = new Konva.Animation((frame) => {
      const dashSpeed = 100; // px per second
      animationRef.current.forEach((line) => {
        if (line) {
          line.dashOffset(-(frame.time * dashSpeed) / 1000);
        }
      });
    }, layer);

    anim.start();

    return () => anim.stop();
  }, []);

  // When Click Anywhere In Page Close ContextMenu
  useEffect(() => {
    document.addEventListener('click', closeContextMenu);



    return () => {
      // Remove the event listener when the component unmounts
      document.removeEventListener('click', closeContextMenu);
    };



  }, []);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [updatedTabIndexDisplay]);

  const removeDuplicates = (array) => {
    const uniqueArray = [];
    for (const item of array) {
      if (!uniqueArray.includes(item)) {
        uniqueArray.push(item);
      }
    }
    return uniqueArray;
  };

  // Function to Handle Context Menu for Tabs
  const handleContextMenu = (e, tabIndex, tabName) => {
    e.preventDefault();
    const x = e.clientX;
    const y = e.clientY;
    setContextMenuPosition({ x, y });
    setOpenContextMenu(true);
    setClickedTabIndex(tabIndex);
    setSelectedTab(tabName);
  };

  // storing active tab index
  const handleTabClick = (tabIndex, name) => {
    setActiveTabIndex(tabIndex);
    setIsPath(name);
  };

  // Function to Close Context Menu
  const closeContextMenu = () => {
    if (!isSubMenu) {
      setOpenContextMenu(false);
      setDeleteContextMenu(false);
      setIsDeviceMenu(false);
    }
  };

  //Function To Open Rename Tab
  const handleRenameTab = () => {
    setIsRenameModel(true);
    setRenameDeviceModal(false);
    setAddNewTag(false);
    closeContextMenu();
  };

  // Function To Save Rename Tab
  const handleSaveRenameTab = () => {
    if (tabNameInput !== selectedTab) {
      const updatedTabs = [...tempTabNames];
      updatedTabs[clickedTabIndex] = tabNameInput;
      setRenameInputValues(RenameInputValues.concat(tabNameInput));
      setIndexesToRename(indexesToRaname.concat(clickedTabIndex));
      setTempTabNames(updatedTabs);
      setTabNameInput('');
    }
    setIsRenameModel(false);
  };





  // Add New Tab Modal Open
  const handleAddNewTab = () => {
    setIsRenameModel(false);
    setRenameDeviceModal(false);
    setAddNewTag(true);
  };

  // Back To View Data Page
  const handleDiscardPage = () => {
    setOpenNewPage(false);
  };

  const handleClosePage = () => {
    setSelectedTabIndex(activeTabIndex);
    setOpenNewPage(false);
  };

  // Saving the New Tab
  const handleSaveTab = () => {
    if (tabNameInput) {
      setTempTabNames(tempTabNames.concat(tabNameInput));
      setInputValues(inputValues.concat(tabNameInput)); // Add the current input value to the array
      setTabNameInput('');
      setAddNewTag(false);
    }
  };



  //Delete Tab
  const handleDeleteTab = () => {
    const originalTabIndex = tabNames.findIndex((tab) => tab === selectedTab);
    setDeletedTabs(deletedTabs.concat(originalTabIndex));
    if (
      clickedTabIndex !== null &&
      clickedTabIndex >= 0 &&
      clickedTabIndex < tempTabNames.length
    ) {
      const updatedTabs = tempTabNames.filter(
        (tab, index) => index !== clickedTabIndex,
      );

      setTempTabNames(updatedTabs);

      // Delete widget from tab

      const copiedTempImages = [...tempImages];

      const remainedTempImages = copiedTempImages.filter(
        (widget) => widget.tabIndex !== clickedTabIndex.toString(),
      );

      const newTabIndexImages = remainedTempImages.map((widget) => {
        const copiedWidget = { ...widget };
        if (copiedWidget.tabIndex > clickedTabIndex) {
          copiedWidget.tabIndex = (
            Number(copiedWidget.tabIndex) - 1
          ).toString();
        }
        return copiedWidget;
      });

      setTempImages(newTabIndexImages);

      // updating position of images
      const newPositionDataImages = {};

      newTabIndexImages.forEach((data, index) => {
        const { x, y, width, height, name, tabIndex, id } = data;

        if (name && name.toLowerCase().includes('image')) {
          if (!newPositionDataImages[tabIndex]) {
            newPositionDataImages[tabIndex] = [];
          }
          newPositionDataImages[tabIndex].push({
            x,
            y,
            name,
            height,
            tabIndex,
            id,
            width,
          });
        }
      });

      setTempTabIndexImages(newPositionDataImages);
      setUpdatedTabIndexImages(newPositionDataImages);

      // updating position of indicator
      const newPositionDataIndicator = {};
      newTabIndexImages.forEach((data, index) => {
        const { x, y, name, tabIndex, id, channelName, deviceType, unit } =
          data;
        if (deviceType === 'Indicator') {
          if (!newPositionDataIndicator[tabIndex]) {
            newPositionDataIndicator[tabIndex] = [];
          }
          newPositionDataIndicator[tabIndex].push({
            x,
            y,
            name,
            channelName,
            tabIndex,
            id,
            deviceType,
            unit,
          });
        }
      });
      setTempTabIndexDevices(newPositionDataIndicator);
      setUpdatedTabIndexDevices(newPositionDataIndicator);

      const newPositionDataDisplay = {};
      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          width,
          height,
          name,
          tabIndex,
          id,
          channelName,
          deviceType,
          bgColor,
          textColor,
          fontSize,
        } = data;
        if (deviceType === 'Display') {
          if (!newPositionDataDisplay[tabIndex]) {
            newPositionDataDisplay[tabIndex] = [];
          }
          newPositionDataDisplay[tabIndex].push({
            x,
            y,
            name,
            channelName,
            tabIndex,
            id,
            deviceType,
            width,
            height,
            bgColor,
            textColor,
            fontSize,
          });
        }
      });

      setTempTabIndexDisplay(newPositionDataDisplay);
      setUpdatedTabIndexDisplay(newPositionDataDisplay);

      //updating position of Controller
      const newPositionDataController = {};
      newTabIndexImages.forEach((data, index) => {
        const { x, y, name, tabIndex, id, channelName, deviceType, unit } =
          data;
        if (deviceType === 'Controller') {
          if (!newPositionDataController[tabIndex]) {
            newPositionDataController[tabIndex] = [];
          }
          newPositionDataController[tabIndex].push({
            x,
            y,
            name,
            channelName,
            tabIndex,
            id,
            deviceType,
            unit,
          });
        }
      });

      setTempTabIndexController(newPositionDataController);
      setUpdatedTabIndexController(newPositionDataController);

      //updating position of Digital I/O
      const newPositionDataIO = {};
      newTabIndexImages.forEach((data, index) => {
        const { x, y, name, tabIndex, id, on, deviceType } = data;
        if (deviceType === 'DigitalIO') {
          if (!newPositionDataIO[tabIndex]) {
            newPositionDataIO[tabIndex] = [];
          }
          newPositionDataIO[tabIndex].push({
            x,
            y,
            name,
            on,
            tabIndex,
            id,
            deviceType,
          });
        }
      });

      setTempTabIndexIO(newPositionDataIO);
      setUpdatedTabIndexIO(newPositionDataIO);

      //updating position of flow meter
      const newPositionDataFlowM = {};
      newTabIndexImages.forEach((data, index) => {
        const { id, x, y, name, tabIndex, channelName, deviceType, unit } =
          data;
        if (deviceType === 'FlowMeter') {
          if (!newPositionDataFlowM[tabIndex]) {
            newPositionDataFlowM[tabIndex] = [];
          }
          newPositionDataFlowM[tabIndex].push({
            x,
            y,
            name,
            channelName,
            tabIndex,
            id,
            deviceType,
            unit,
          });
        }
      });
      setTempTabIndexFlowM(newPositionDataFlowM);
      setUpdatedTabIndexFlowM(newPositionDataFlowM);

      //updating position of energy meter
      const newPositionDataEnergyM = {};
      newTabIndexImages.forEach((data, index) => {
        const { x, y, name, tabIndex, id, channelName, deviceType, unit } =
          data;
        if (deviceType === 'EnergyMeter') {
          if (!newPositionDataEnergyM[tabIndex]) {
            newPositionDataEnergyM[tabIndex] = [];
          }
          newPositionDataEnergyM[tabIndex].push({
            x,
            y,
            name,
            channelName,
            tabIndex,
            id,
            deviceType,
            unit,
          });
        }
      });
      setTempTabIndexEnergyM(newPositionDataEnergyM);
      setUpdatedTabIndexEnergyM(newPositionDataEnergyM);

      const newPositionDataMotor = {};
      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          width,
          height,
          name,
          tabIndex,
          id,
          deviceType,
          on,
          channelName,
        } = data;
        if (deviceType === 'Motor') {
          if (!newPositionDataMotor[tabIndex]) {
            newPositionDataMotor[tabIndex] = [];
          }
          newPositionDataMotor[tabIndex].push({
            x,
            y,
            name,
            width,
            height,
            tabIndex,
            id,
            deviceType,
            on,
            channelName,
          });
        }
      });
      setTempTabIndexMotor(newPositionDataMotor);
      setUpdatedTabIndexMotor(newPositionDataMotor);

      //For text

      const newPositionDataText = {};
      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          width,
          height,
          name,
          tabIndex,
          id,
          channelName,
          text,
          deviceType,
          bgColor,
          textColor,
          fontSize,
          alignHorizontally,
          alignVertically,
        } = data;

        if (deviceType === 'Text') {
          if (!newPositionDataText[tabIndex]) {
            newPositionDataText[tabIndex] = [];
          }
          newPositionDataText[tabIndex].push({
            x,
            y,
            name,
            channelName,
            tabIndex,
            id,
            deviceType,
            width,
            height,
            bgColor,
            textColor,
            fontSize,
            text,
            alignHorizontally,
            alignVertically,

          });
        }
      });

      setTempTabIndexText(newPositionDataText);
      setUpdatedTabIndexText(newPositionDataText);

      //updating position of Line Chart
      const newPositionDataLineChart = {};
      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          width,
          height,
          name,
          tabIndex,
          id,
          chartChannel,
          deviceType,
          hour,
          minute,
          channelsGroup,
        } = data;
        if (deviceType === 'LineChart') {
          if (!newPositionDataLineChart[tabIndex]) {
            newPositionDataLineChart[tabIndex] = [];
          }
          newPositionDataLineChart[tabIndex].push({
            x,
            y,
            name,
            chartChannel,
            tabIndex,
            id,
            deviceType,
            width,
            height,
            hour,
            minute,
            channelsGroup,
          });
        }
      });
      setTempTabIndexLineChart(newPositionDataLineChart);
      setUpdatedTabIndexLineChart(newPositionDataLineChart);

      //Updating position of Pie chart
      const newPositionDataPieChart = {};

      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          width,
          height,
          name,
          tabIndex,
          id,
          chartChannel,
          deviceType,
          channelsGroup,
        } = data;
        if (deviceType === 'PieChart') {
          if (!newPositionDataPieChart[tabIndex]) {
            newPositionDataPieChart[tabIndex] = [];
          }

          newPositionDataPieChart[tabIndex].push({
            x,
            y,
            name,
            chartChannel,
            tabIndex,
            id,
            deviceType,
            width,
            height,
            channelsGroup,
          });
        }
      });

      setTempTabIndexPieChart(newPositionDataPieChart);
      setUpdatedTabIndexPieChart(newPositionDataPieChart);

      //Updating position of Bar chart
      const newPositionDataBarChart = {};
      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          width,
          height,
          name,
          tabIndex,
          id,
          chartChannel,
          deviceType,
          channelsGroup,
        } = data;
        if (deviceType === 'BarChart') {
          if (!newPositionDataBarChart[tabIndex]) {
            newPositionDataBarChart[tabIndex] = [];
          }
          newPositionDataBarChart[tabIndex].push({
            x,
            y,
            name,
            chartChannel,
            tabIndex,
            id,
            deviceType,
            width,
            height,
            channelsGroup,
          });
        }
      });

      setTempTabIndexBarChart(newPositionDataBarChart);
      setUpdatedTabIndexBarChart(newPositionDataBarChart);

      //Updating position of Histogram
      const newPositionDataHistogram = {};
      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          width,
          height,
          name,
          tabIndex,
          id,
          chartChannel,
          deviceType,
          hour,
          minute,
          channelsGroup,
        } = data;
        if (deviceType === 'Histogram') {
          if (!newPositionDataHistogram[tabIndex]) {
            newPositionDataHistogram[tabIndex] = [];
          }
          newPositionDataHistogram[tabIndex].push({
            x,
            y,
            name,
            chartChannel,
            tabIndex,
            id,
            deviceType,
            width,
            height,
            hour,
            minute,
            channelsGroup,
          });
        }
      });
      setTempTabIndexHistogram(newPositionDataHistogram);
      setUpdatedTabIndexHistogram(newPositionDataHistogram);

      //Updating position of Gauge
      const newPositionDataGauge = {};
      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          name,
          tabIndex,
          id,
          chartChannel,
          deviceType,
          maxVal,
          minVal,
          width,
          height,
        } = data;
        if (deviceType === 'Gauge') {
          if (!newPositionDataGauge[tabIndex]) {
            newPositionDataGauge[tabIndex] = [];
          }
          newPositionDataGauge[tabIndex].push({
            x,
            y,
            name,
            chartChannel,
            tabIndex,
            id,
            deviceType,
            minVal,
            maxVal,
            width,
            height,
          });
        }
      });
      setTempTabIndexGauge(newPositionDataGauge);
      setUpdatedTabIndexGauge(newPositionDataGauge);

      //Updating position of Progress Bar
      const newPositionDataProgress = {};
      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          name,
          tabIndex,
          id,
          chartChannel,
          deviceType,
          maxVal,
          minVal,
          rotate,
          width,
          height,
        } = data;
        if (deviceType === 'ProgressBar') {
          if (!newPositionDataProgress[tabIndex]) {
            newPositionDataProgress[tabIndex] = [];
          }
          newPositionDataProgress[tabIndex].push({
            x,
            y,
            name,
            chartChannel,
            tabIndex,
            id,
            deviceType,
            maxVal,
            minVal,
            rotate,
            width,
            height,
          });
        }
      });
      setTempTabIndexProgress(newPositionDataProgress);
      setUpdatedTabIndexProgress(newPositionDataProgress);

      //Updating position of Grid
      const newPositionDataGrid = {};
      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          name,
          tabIndex,
          id,
          chartChannel,
          deviceType,
          width,
          height,
        } = data;
        if (deviceType === 'Grid') {
          if (!newPositionDataGrid[tabIndex]) {
            newPositionDataGrid[tabIndex] = [];
          }
          newPositionDataGrid[tabIndex].push({
            x,
            y,
            name,
            chartChannel,
            tabIndex,
            id,
            deviceType,
            width,
            height,
          });
        }
      });
      setTempTabIndexGrid(newPositionDataGrid);
      setUpdatedTabIndexGrid(newPositionDataGrid);

      const newPositionDataTable = {};
      newTabIndexImages.forEach((data, index) => {
        const {
          x,
          y,
          name,
          tabIndex,
          id,
          chartChannel,
          deviceType,
          width,
          height,
          column,
        } = data;
        if (deviceType === 'Table') {
          if (!newPositionDataTable[tabIndex]) {
            newPositionDataTable[tabIndex] = [];
          }
          newPositionDataTable[tabIndex].push({
            x,
            y,
            name,
            chartChannel,
            tabIndex,
            id,
            deviceType,
            width,
            height,
            column,
          });
        }
      });
      setTempTabIndexTable(newPositionDataTable);
      setUpdatedTabIndexTable(newPositionDataTable);

      const newPositionDatLines = {};
      newTabIndexImages.forEach((data, index) => {
        const { x, y, name, tabIndex, id, deviceType, width, angle } = data;
        if (deviceType === 'Line') {
          if (!newPositionDatLines[tabIndex]) {
            newPositionDatLines[tabIndex] = [];
          }
          newPositionDatLines[tabIndex].push({
            x,
            y,
            name,
            tabIndex,
            id,
            deviceType,
            width,
            angle,
          });
        }
      });
      setTempTabIndexLines(newPositionDatLines);
      setUpdatedTabIndexLines(newPositionDatLines);
    }
  };

  const HandleDeleteContextMenu = (e, imgIndex, tempImage, imageData) => {
    e.preventDefault();
    setDeleteContextMenu(true);
    const x = e.clientX;
    const y = e.clientY;
    setDeleteContextPosi({ x, y });
    setClickedImgIndex(imgIndex);
    setClickedDeviceIndex(imgIndex);
    setSelectedImg(imageData);
    setCurrentDevice(tempImage);
    setSelectedDevice(imageData);
  };

  // Displaying Saved Images

  const TempGenerateImage = () => {
    const selectedTabImages = tempTabIndexImages[activeTabIndex];
    if (Array.isArray(selectedTabImages)) {
      return selectedTabImages.map((tempImage, imgIndex) => {

        const { x, y, width, height, name, id, zIndex } = tempImage;

        const imageStyle = {
          display: 'flex',
          position: 'absolute',
          top: y + 'px',
          left: x + 'px',
          resize: 'both',
          width: width,
          height: height,
          zIndex: zIndex ?? "1"
        };

        const deviceType = "Image";

        // const imagePositions = tempImagePosition[imgIndex];

        return (
          <Draggble
            onStop={(e, data) =>
              TempHandleDragStop(e, data, imgIndex, tempImage, x, y, id, {
                setTempImagePosition,
                setImagesToUpdate,
                imagesToUpdate,
                tempImages,
                setTempImages,
                tempTabIndexImages,
                activeTabIndex,
                setUpdatedTabIndexImages,
              })
            }
            bounds="parent"
          // position={imagePositions}
          >
            <div
              style={imageStyle}
              id={`tempImg-${imgIndex}`}
              onContextMenu={(e) => {
                TempGetDimensions(e, imgIndex, id, tempImages, setTempImages);
                HandleDeleteContextMenu(e, imgIndex, deviceType, tempImage);
              }}
              className={styles.addImg}
              ref={(el) => (imagesRefs.current[imgIndex] = el)}
            >
              <img src={name} alt="" key={imgIndex} />
            </div>
          </Draggble>
        );
      });
    }
  };

  useEffect(() => {
    // saved widgets
    setTempTabIndexImages(updatedTabIndexImages);
    setTempTabIndexDevices(updatedTabIndexDevices);
    setTempTabIndexController(updatedTabIndexController);
    setTempTabIndexIO(updatedTabIndexIO);
    setTempTabIndexFlowM(updatedTabIndexFlowM);
    setTempTabIndexEnergyM(updatedTabIndexEnergyM);
    setTempTabIndexLineChart(updatedTabIndexLineChart);
    setTempTabIndexPieChart(updatedTabIndexPieChart);
    setTempTabIndexBarChart(updatedTabIndexBarChart);
    setTempTabIndexHistogram(updatedTabIndexHistogram);
    setTempTabIndexGauge(updatedTabIndexGauge);
    setTempTabIndexProgress(updatedTabIndexProgress);
    setTempTabIndexGrid(updatedTabIndexGrid);
    setTempTabIndexTable(updatedTabIndexTable);
    setTempTabIndexMotor(updatedTabIndexMotor);
    setTempTabIndexDisplay(updatedTabIndexDisplay);
    setTempTabIndexText(updatedTabIndexText);
    setTempTabIndexLines(updatedTabIndexLines);
    setTempTabIndexCircle(updatedTabIndexCircle);
    setTempTabIndexSquare(updatedTabIndexSquare);
    setTempTabIndexPolygone(updatedTabIndexPolygone);
    setTempTabIndexPipe(updatedTabIndexPipe);
    setTempTabIndexCircularProgress(updatedTabIndexCircularProgress);
    setTempTabIndexDoughnut(updatedTabIndexDoughnut);
    setTempTabIndexCheckbox(updatedTabIndexCheckbox);
    setTempTabIndexRadio(updatedTabIndexRadio);
    setTempTabIndexSwitch(updatedTabIndexSwitch);

  }, [activeTabIndex]);

  const handleChannelsBtn = () => {
    setIsDeviceMenu(false);



    if (currentDevice === 'Grid') {
      setIsChannelCheckBox(true);
    } else {
      setIsChannels(true);
    }

    if (currentDevice === "Lamp") {
      setLampStatus(prevState => selectedDevice?.lampStatus ? selectedDevice?.lampStatus : prevState);
    }
  };

  // open modal to update device name
  const handleRenameDeviceModal = () => {
    setRenameDeviceModal(true);
    setAddNewTag(false);
    setIsRenameModel(false);
  };

  // getting selected pv/sv channels
  const handleSelectChange = (e) => {
    if (currentDevice === 'PieChart') {
      setPlusIcon(true);
      const graphChannel = pieChartChannels.concat(e.target.value);
      const newSetChannels = removeDuplicates(graphChannel);
      setPieChartChannels(newSetChannels);
    }

    if (currentDevice === 'BarChart') {
      setPlusIcon(true);
      const graphChannel = barChartChannels.concat(e.target.value);
      const newSetChannels = removeDuplicates(graphChannel);
      setBarChartChannels(newSetChannels);
    }

    if (currentDevice === 'LineChart') {
      setPlusIcon(true);
      const graphChannel = lineChartChannels.concat(e.target.value);
      const newSetChannels = removeDuplicates(graphChannel);
      setLineChartChannels(newSetChannels);
    }

    if (currentDevice === 'Histogram') {
      setPlusIcon(true);
      const graphChannel = histogramChannels.concat(e.target.value);
      const newSetChannels = removeDuplicates(graphChannel);
      setHistogramChannels(newSetChannels);
    }

    if (currentDevice === 'Grid') {
      setPlusIcon(true);
      const graphChannel = gridChannels.concat(e.target.value);
      const newSetChannels = removeDuplicates(graphChannel);
      setGridChannels(newSetChannels);
    }

    if (currentDevice === 'Table') {
      setPlusIcon(true);
      const graphChannel = tableChannels.concat(e.target.value);
      const newSetChannels = removeDuplicates(graphChannel);
      setTableChannels(newSetChannels);
    }

    if (currentDevice === 'Doughnut') {
      setPlusIcon(true);
      const doughnutChannel = doughnutChannels.concat(e.target.value);
      const newSetChannels = removeDuplicates(doughnutChannel);
      setDoughnutChannels(newSetChannels);
    }
  };

  const handlePlusIcon = () => {
    setDisplaySelectTag(displaySelectTag.concat('selectTag'));
  };

  const handleAllSelect = () => {
    const selectAll = document.getElementById('selectAllOption').checked;
    const checkBoxes = document.getElementsByName('checkBox');

    for (let i = 0; i < checkBoxes.length; i++) {
      checkBoxes[i].checked = selectAll;
    }

    const selectedHeaders = selectAll
      ? tableData.map((data) => data.Header)
      : [];
    setGridChannels(selectedHeaders);
    setSelectAllCheck(selectAll);
  };

  const handleCheckBox = (event, index, header) => {
    setSelectAllCheck(false);
    const checkBox = event.target;
    const checkBoxValue = checkBox.checked;
    if (checkBoxValue) {
      setGridChannels((prevState) => [...prevState, header]);
    } else {
      setGridChannels((prevState) =>
        prevState.filter((item) => item !== header),
      );
    }
  };

  const handleTimePeriod = () => {
    setIsTimePeriod(true);
  };

  const handleEndTimeSelect = () => {
    const timeValue = document.getElementById('endTime').value;
    setEndSelect(timeValue);
  };

  const handleEndChange = (e) => {
    if (endSelect === 'Days') {
      setEndDays(parseInt(e.target.value));
    }
    if (endSelect === 'Hours') {
      setEndHours(parseInt(e.target.value));
    }
    if (endSelect === 'Minutes') {
      setEndMinutes(parseInt(e.target.value));
    }
  };

  const handleEndIncrease = (e) => {
    if (endSelect === 'Days') {
      setEndDays(parseInt(endDays) + 1);
    }
    if (endSelect === 'Hours') {
      setEndHours(parseInt(endHours) + 1);
    }
    if (endSelect === 'Minutes') {
      setEndMinutes(parseInt(endMinutes) + 1);
    }
  };

  const handleEndDecrease = () => {
    if (endSelect === 'Days') {
      if (endDays > 0) {
        setEndDays(parseInt(endDays) - 1);
      }
    }
    if (endSelect === 'Hours') {
      if (endHours > 0) {
        setEndHours(parseInt(endHours) - 1);
      }
    }
    if (endSelect === 'Minutes') {
      if (endMinutes > 0) {
        setEndMinutes(parseInt(endMinutes) - 1);
      }
    }
  };

  const handleCloseTimePeriod = () => {
    setIsTimePeriod(false);
    setEndHours(0);
    setEndMinutes(0);
  };

  // Function to handle the position of a info component in a overview tab
  const handleOverviewInfoDrop = (e, data, id, x, y) => {
    const newPosition = { x: data.x, y: data.y };
    setOverviewInfoPosi(newPosition);
    if (Object.keys(tempTabIndexOverviewInfo).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedTempImages = [...tempImages];
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        x: x !== null ? x + data.x : 70,
        y: y !== null ? y + data.y : 20,
      };
      updatedTempImages[originalDeviceIndex] = updatedData;

      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  // Function to handle the position of a graph component in a overview tab
  const handleOverviewGraphDrop = (e, data, id, x, y) => {
    const newPosition = { x: data.x, y: data.y };
    setOverviewGraphPosi(newPosition);
    if (Object.keys(tempTabIndexOverviewGraph).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedTempImages = [...tempImages];
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        x: x !== null ? x + data.x : 570,
        y: y !== null ? y + data.y : 70,
      };
      updatedTempImages[originalDeviceIndex] = updatedData;

      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  // Function to handle the width/height of a graph component in a overview tab
  const handleOverviewGraphDimension = (e, id) => {
    e.preventDefault();
    const updatedTempImages = [...tempImages];
    const dimension = document.getElementById('overviewGraph');
    const newDimension = {
      width: dimension.style.width,
      height: dimension.style.height,
    };

    setOverviewGraphDimension(newDimension);
    if (Object.keys(tabIndexOverviewGraph).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        width: newDimension.width,
        height: newDimension.height,
      };
      updatedTempImages[originalDeviceIndex] = updatedData;

      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  // Function to handle the position of a graph component in a livedata tab

  const handleLiveDataGraphDrop = (e, data, id, x, y) => {
    const newPosition = { x: data.x, y: data.y };

    setLiveDataGraphPosi(newPosition);
    if (Object.keys(tempTabIndexLiveDataGraph).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedTempImages = [...tempImages];
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        x: x !== null ? x + data.x : 277,
        y: y !== null ? y + data.y : 60,
      };
      updatedTempImages[originalDeviceIndex] = updatedData;
      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  // Function to handle the width/height of a graph component in a livedata tab

  const handleLiveDataDimension = (e, id) => {
    e.preventDefault();
    const updatedTempImages = [...tempImages];
    const dimension = document.getElementById('liveDataGraph');
    const newDimension = {
      width: dimension.style.width,
      height: dimension.style.height,
    };

    setLiveDataGraphDimension(newDimension);
    if (Object.keys(tabIndexLiveDataGraph).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        width: newDimension.width,
        height: newDimension.height,
      };
      updatedTempImages[originalDeviceIndex] = updatedData;
      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  // Function to handle the position of a table component in a 24-hour tab
  const handleLastDayTableDrop = (e, data, id, x, y) => {
    const newPosition = { x: data.x, y: data.y };
    setLastDayTablePosi(newPosition);
    if (Object.keys(tempTabIndexLastDayTable).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedTempImages = [...tempImages];
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        x: x !== null ? x + data.x : 200,
        y: y !== null ? y + data.y : 10,
      };
      updatedTempImages[originalDeviceIndex] = updatedData;
      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  // Function to handle the width/height of a table component in a 24-hour tab
  const handleLastDayTableDimension = (e, id) => {
    e.preventDefault();
    const updatedTempImages = [...tempImages];
    const dimension = document.getElementById('lastDayTable');
    const newDimension = {
      width: dimension.style.width,
      height: dimension.style.height,
    };

    setLastDayTableDimension(newDimension);
    if (Object.keys(tabIndexLastDayTable).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        width: newDimension.width,
        height: newDimension.height,
      };
      updatedTempImages[originalDeviceIndex] = updatedData;
      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  // Function to handle the position of a graph component in a 24-hour tab
  const handleLastDayGraphDrop = (e, data, id, x, y) => {
    const newPosition = { x: data.x, y: data.y };
    setLastDayGraphPosi(newPosition);
    if (Object.keys(tempTabIndexLastDayGraph).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedTempImages = [...tempImages];
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        x: x !== null ? x + data.x : 500,
        y: y !== null ? y + data.y : 80,
      };

      updatedTempImages[originalDeviceIndex] = updatedData;
      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  // Function to handle the width/height of a graph component in a 24-hour tab
  const handleLastDayGraphDimension = (e, id) => {
    e.preventDefault();
    const updatedTempImages = [...tempImages];
    const dimension = document.getElementById('lastDayGraph');
    const newDimension = {
      width: dimension.style.width,
      height: dimension.style.height,
    };

    setLastDayGraphDimension(newDimension);
    if (Object.keys(tabIndexLastDayGraph).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        width: newDimension.width,
        height: newDimension.height,
      };
      updatedTempImages[originalDeviceIndex] = updatedData;
      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  // Function to handle the width/height in a Gridview Tab
  const handleDefaultGridDimension = (e, id) => {
    e.preventDefault();
    const updatedTempImages = [...tempImages];
    const dimension = document.getElementById('DefaultGrid');
    const newDimension = {
      width: dimension.style.width,
      height: dimension.style.height,
    };

    setDefaultGridDimension(newDimension);
    if (Object.keys(tabIndexDefaultGrid).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        width: newDimension.width,
        height: newDimension.height,
      };
      updatedTempImages[originalDeviceIndex] = updatedData;
      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  // Function to handle position of grid view of tab
  const handleDefaultGridDrop = (e, data, id, x, y) => {
    const newPosition = { x: data.x, y: data.y };
    setDefaultGridPosi(newPosition);
    if (Object.keys(tempTabIndexDefaultGrid).length > 0) {
      const originalDeviceIndex = tempImages.findIndex(
        (data) => data.id === id,
      );
      const updatedTempImages = [...tempImages];
      const updatedData = {
        ...updatedTempImages[originalDeviceIndex],
        x: x + data.x,
        y: y + data.y,
      };
      updatedTempImages[originalDeviceIndex] = updatedData;
      setTempImages(updatedTempImages);
      setUpdatedImages(updatedTempImages);
    }
  };

  const handlePageClick = () => {
    if (isMotorOptions) {
      setIsMotorOptions(false);
    }

    if (isDeviceOption) {
      setIsDeviceOption(false);
    }

    if (isGraphOptions) {
      setIsGraphOptions(false);
    }

    if (isDrawingObjects) {
      setIsDrawingObjects(false);
    }

    if (isBtnOptions) {
      setIsBtnOptions(false);
    }

    // if (isSubMenu) {
    //   setIsSubMenu(false);
    // }


  };

  const handleFontSizeInputChange = (e) => {
    const value = parseInt(e.target.value);
    if (currentDevice === 'Display') {
      setFontSize(value);
    } else if (currentDevice === 'Text') {
      setTextFontSize(value);
    } else if (currentDevice === "Link") {
      setTextFontSize(value);
    } else if (currentDevice === "Square") {
      setTextFontSize(value)
    } else if (currentDevice === "Circle") {
      setTextFontSize(value)
    } else if (currentDevice === "Gauge") {
      setTextFontSize(value)
    } else if (currentDevice === "ProgressBar") {
      setTextFontSize(value)
    } else if (currentDevice === "Slider") {
      setTextFontSize(value);
    }
  };

  // Function Increase font size

  const handleIncreaseFontSize = () => {
    if (currentDevice === 'Display') {
      setFontSize(fontSize + 1);
    } else if (currentDevice === 'Text') {
      setTextFontSize(textFontSize + 1);
    } else if (currentDevice === 'Link') {
      setTextFontSize(textFontSize + 1);
    } else if (currentDevice === "Square") {
      setTextFontSize(textFontSize + 1)
    } else if (currentDevice === "Circle") {
      setTextFontSize(textFontSize + 1)
    } else if (currentDevice === "Gauge") {
      setTextFontSize(textFontSize + 1)
    } else if (currentDevice === "ProgressBar") {
      setTextFontSize(textFontSize + 1)
    } else if (currentDevice === "Slider") {
      setTextFontSize(textFontSize + 1)
    }
  };

  // Function Decrease font size
  const handleDecreaseFontSize = () => {
    if (currentDevice === 'Display') {
      if (fontSize > 1) {
        setFontSize(fontSize - 1);
      }
    } else if (currentDevice === 'Text') {
      setTextFontSize(textFontSize - 1);
    } else if (currentDevice === 'Link') {
      setTextFontSize(textFontSize - 1);
    } else if (currentDevice === 'Square') {
      setTextFontSize(textFontSize - 1);
    } else if (currentDevice === 'Circle') {
      setTextFontSize(textFontSize - 1);
    } else if (currentDevice === 'Gauge') {
      setTextFontSize(textFontSize - 1);
    } else if (currentDevice === 'ProgressBar') {
      setTextFontSize(textFontSize - 1);
    } else if (currentDevice === "Slider") {
      setTextFontSize(textFontSize + 1)
    }
  };

  const handleLineMouseDown = (e) => {
    if (!isDrawing) return;

    const canvas = lineCanvasRef.current;

    const rect = canvas.getBoundingClientRect();



    setLineStartPosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });




    setIsStartedDrawing(true);
  };

  const handleLineMouseMove = (e) => {
    if (!isStartedDrawing || !isDrawing) return;

    const canvas = lineCanvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();

    const currentPosition = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };

    // Clear the canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // Draw the current line
    ctx.beginPath();
    ctx.moveTo(lineStartPosition.x, lineStartPosition.y);
    ctx.lineTo(currentPosition.x, currentPosition.y);
    ctx.strokeStyle = 'black';
    ctx.lineWidth = 2;
    ctx.stroke();
  };

  const handleLineMouseUp = (e) => {
    const canvas = lineCanvasRef.current;
    const rect = canvas.getBoundingClientRect();

    const endPosition = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };

    const deltaX = endPosition.x - lineStartPosition.x;
    const deltaY = endPosition.y - lineStartPosition.y;

    const length = Math.sqrt(deltaX ** 2 + deltaY ** 2);
    const angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI);

    //  TRUE bounding box
    const boxWidth = Math.abs(deltaX);
    const boxHeight = Math.abs(deltaY);

    //  top-left corner of box
    const x = Math.min(lineStartPosition.x, endPosition.x);
    const y = Math.min(lineStartPosition.y, endPosition.y);

    setMultipleLines((prev) => [
      ...prev,
      {
        deviceName: "Line",
        type: "Line",
        tabIndex: activeTabIndex,
        x,
        y,
        width: boxWidth,
        height: boxHeight,
        length,
        angle,
        deltaX,
        deltaY,
      },
    ]);
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    setIsDrawing(false);
    setIsStartedDrawing(false);
  };

  const handleAddButton = () => {


    if (currentDevice === "Radio") {

      if (Object.keys(tempTabIndexRadio).length > 0) {

        const particularDevice = tempTabIndexRadio[activeTabIndex];

        if (particularDevice !== undefined) {

          const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
          );

          if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {

            let temporaryWidgets = [...tempImages];

            const updatedData = {
              ...temporaryWidgets[originalDeviceIndex],
              points: [...temporaryWidgets[originalDeviceIndex].points, "Button"]
            };

            temporaryWidgets[originalDeviceIndex] = updatedData;

            setTempImages(temporaryWidgets);
            setUpdatedImages(temporaryWidgets);

            let oldtabIndexRadio = [...tempTabIndexRadio[activeTabIndex]];

            const organizedDeviceIndex = oldtabIndexRadio.findIndex(
              (data) => data.id === selectedDevice.id
            );


            const newUpdatedData = {
              ...oldtabIndexRadio[organizedDeviceIndex],
              points: [...oldtabIndexRadio[organizedDeviceIndex].points, "Button"]
            };

            oldtabIndexRadio[organizedDeviceIndex] = newUpdatedData;

            const newTempTabIndexDevices = {
              [activeTabIndex]: oldtabIndexRadio,
            };

            setTempTabIndexRadio(newTempTabIndexDevices);
            setUpdatedTabIndexRadio(newTempTabIndexDevices);

          }
        }
      }

      if (multipleRadio.length > 1) {
        if (!selectedDevice?.id) {

          const updatedDeviceName = [...multipleRadio];
          const deviceToUpdate = multipleRadio.findIndex(
            (element, index) => index === clickedDeviceIndex
          );

          updatedDeviceName[deviceToUpdate].points = [...updatedDeviceName[deviceToUpdate].points, "Button"]

          setMultipleRadio(updatedDeviceName);
        }
      }

    }

  }

  const handleDeleteButton = () => {
    if (currentDevice === "Radio") {
      if (Object.keys(tempTabIndexRadio).length > 0) {
        const particularDevice = tempTabIndexRadio[activeTabIndex];

        if (particularDevice !== undefined) {
          const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
          );

          if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
            let temporaryWidgets = [...tempImages];

            // remove last "Button" from points
            let updatedPoints = [...temporaryWidgets[originalDeviceIndex].points];
            updatedPoints.pop();

            const updatedData = {
              ...temporaryWidgets[originalDeviceIndex],
              points: updatedPoints
            };

            temporaryWidgets[originalDeviceIndex] = updatedData;

            setTempImages(temporaryWidgets);
            setUpdatedImages(temporaryWidgets);

            let oldtabIndexRadio = [...tempTabIndexRadio[activeTabIndex]];

            const organizedDeviceIndex = oldtabIndexRadio.findIndex(
              (data) => data.id === selectedDevice.id
            );

            let updatedTabPoints = [...oldtabIndexRadio[organizedDeviceIndex].points];
            updatedTabPoints.pop();

            const newUpdatedData = {
              ...oldtabIndexRadio[organizedDeviceIndex],
              points: updatedTabPoints
            };

            oldtabIndexRadio[organizedDeviceIndex] = newUpdatedData;

            const newTempTabIndexDevices = {
              [activeTabIndex]: oldtabIndexRadio,
            };

            setTempTabIndexRadio(newTempTabIndexDevices);
            setUpdatedTabIndexRadio(newTempTabIndexDevices);
          }
        }
      }

      if (multipleRadio.length > 1) {
        if (!selectedDevice?.id) {
          const updatedDeviceName = [...multipleRadio];
          const deviceToUpdate = multipleRadio.findIndex(
            (element, index) => index === clickedDeviceIndex
          );

          let updatedPoints = [...updatedDeviceName[deviceToUpdate].points];
          updatedPoints.pop();

          updatedDeviceName[deviceToUpdate].points = updatedPoints;

          setMultipleRadio(updatedDeviceName);
        }
      }
    }
  };

  const handleSelectRadioButton = (selectedIndex, deviceType, deviceIndex) => {


    if (deviceType === "Radio") {

      if (Object.keys(tempTabIndexRadio).length > 0) {
        const particularDevice = tempTabIndexRadio[activeTabIndex];

        if (particularDevice !== undefined) {
          const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice
          );

          if (particularDevice[clickedDeviceIndex]?.id === selectedDevice) {
            let temporaryWidgets = [...tempImages];

            const updatedData = {
              ...temporaryWidgets[originalDeviceIndex],
              selectedIndex: selectedIndex,   // store selected radio index
            };

            temporaryWidgets[originalDeviceIndex] = updatedData;

            setTempImages(temporaryWidgets);
            setUpdatedImages(temporaryWidgets);

            let oldtabIndexRadio = [...tempTabIndexRadio[activeTabIndex]];

            const organizedDeviceIndex = oldtabIndexRadio.findIndex(
              (data) => data.id === selectedDevice
            );

            const newUpdatedData = {
              ...oldtabIndexRadio[organizedDeviceIndex],
              selectedIndex: selectedIndex,
            };

            oldtabIndexRadio[organizedDeviceIndex] = newUpdatedData;

            const newTempTabIndexDevices = {
              [activeTabIndex]: oldtabIndexRadio,
            };

            setTempTabIndexRadio(newTempTabIndexDevices);
            setUpdatedTabIndexRadio(newTempTabIndexDevices);
          }
        }
      }

      if (multipleRadio.length > 1) {

        if (!selectedDevice?.id) {
          const updatedDeviceName = [...multipleRadio];
          const deviceToUpdate = multipleRadio.findIndex(
            (element, index) => index === deviceIndex
          );

          updatedDeviceName[deviceToUpdate].selectedIndex = selectedIndex;
          setMultipleRadio(updatedDeviceName);
          setUpdatedMultipleRadio(updatedDeviceName);
        }
      }
    }

  };

  const handleSelectCheckbox = (deviceIndex) => {


    if (Object.keys(tempTabIndexCheckbox).length > 0) {
      const particularDevice = tempTabIndexCheckbox[activeTabIndex];

      if (particularDevice !== undefined) {
        const originalDeviceIndex = tempImages.findIndex(
          (data) => data.id === selectedDevice
        );

        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice) {
          let temporaryWidgets = [...tempImages];

          const updatedData = {
            ...temporaryWidgets[originalDeviceIndex],
            on: !temporaryWidgets[originalDeviceIndex].on,
          };

          temporaryWidgets[originalDeviceIndex] = updatedData;

          setTempImages(temporaryWidgets);
          setUpdatedImages(temporaryWidgets);

          let oldtabIndexCheckbox = [...tempTabIndexCheckbox[activeTabIndex]];

          const organizedDeviceIndex = oldtabIndexCheckbox.findIndex(
            (data) => data.id === selectedDevice
          );

          const newUpdatedData = {
            ...oldtabIndexCheckbox[organizedDeviceIndex],
            on: !oldtabIndexCheckbox[organizedDeviceIndex].on,
          };

          oldtabIndexCheckbox[organizedDeviceIndex] = newUpdatedData;

          const newTempTabIndexDevices = {
            [activeTabIndex]: oldtabIndexCheckbox,
          };

          setTempTabIndexCheckbox(newTempTabIndexDevices);
          setUpdatedTabIndexCheckbox(newTempTabIndexDevices);
        }
      }
    }

    if (multipleCheckbox.length > 1) {

      if (!selectedDevice?.id) {
        const updatedDeviceName = [...multipleCheckbox];
        const deviceToUpdate = multipleCheckbox.findIndex(
          (element, index) => index === deviceIndex
        );

        updatedDeviceName[deviceToUpdate].on = !updatedDeviceName[deviceToUpdate].on;
        setMultipleCheckbox(updatedDeviceName);
        setUpdatedMultipleCheckbox(updatedDeviceName);
      }
    }
  }

  const handlePushBtnOn = (deviceIndex, device) => {
    if (Object.keys(tempTabIndexPush).length > 0) {
      const particularDevice = tempTabIndexPush[activeTabIndex];


      if (particularDevice !== undefined) {
        const originalDeviceIndex = tempImages.findIndex(
          (data) => data.id === device.id
        );
        if (particularDevice[deviceIndex]?.id === device.id) {
          let temporaryWidgets = [...tempImages];

          const updatedData = {
            ...temporaryWidgets[originalDeviceIndex],
            on: 1
          };

          temporaryWidgets[originalDeviceIndex] = updatedData;

          setTempImages(temporaryWidgets);
          setUpdatedImages(temporaryWidgets);

          let oldtabIndexPush = [...tempTabIndexPush[activeTabIndex]];

          const organizedDeviceIndex = oldtabIndexPush.findIndex(
            (data) => data.id === device.id
          );

          const newUpdatedData = {
            ...oldtabIndexPush[organizedDeviceIndex],
            on: 1,
          };

          oldtabIndexPush[organizedDeviceIndex] = newUpdatedData;

          const newTempTabIndexDevices = {
            [activeTabIndex]: oldtabIndexPush,
          };


          setTempTabIndexPush(newTempTabIndexDevices);
          setUpdatedTabIndexPush(newTempTabIndexDevices);
        }
      }
    }

    if (multiplePush.length > 1) {

      if (!device?.id) {
        const updatedDeviceName = [...multiplePush];
        const deviceToUpdate = multiplePush.findIndex(
          (element, index) => index === deviceIndex
        );

        updatedDeviceName[deviceToUpdate].on = 1;
        setMultiplePush(updatedDeviceName);
        setUpdatedMultiplePush(updatedDeviceName);
      }
    }
  }

console.log(selectedDevice  , "selectedDevice")
  const handleHorizontalMoveClick = (e) => {
    e.preventDefault();
    setIsHorizontalMove(true);

    setHorizontalMoveChannel(selectedDevice?.horizontalMoveChannel || "");
    setConditionValue(selectedDevice?.conditionValue || {});
    setMoveValue(selectedDevice?.moveValue || {});

  }

  const handleVerticalMoveClick = (e) => {
    e.preventDefault();
    setIsVerticalMove(true);

    setVerticalMoveChannel(selectedDevice?.verticalMoveChannel || "");
    setConditionValue(selectedDevice?.conditionValue || {});
    setMoveValue(selectedDevice?.moveValue || {});

  }

  const handleMouseEnter = (e, item) => {

    setSubMenuPosi({ x: e.pageX, y: e.pageY });
    setIsSubMenu(true);
  };

  const handleMouseLeave = () => {

    setSubMenuPosi({ x: 0, y: 0 });
    setIsSubMenu(false);

  };

  const handleOpenLineStyle = () => {
    setIsLineStyle(true);
    setLineStyle(selectedDevice?.lineStyle)
    setIsCurveLine(selectedDevice?.isCurveLine);
    setIsSteppedLine(selectedDevice?.isSteppedLine);

  }

  const handleOpenYAxisRange = () => {
    setIsYRange(true);
    setYRange({
      min: selectedDevice?.minY ? selectedDevice?.minY : yRange.min,
      max: selectedDevice?.maxY ? selectedDevice?.maxY : yRange.max
    })
  }

  const handleOpenGraphInterval = () => {

    setIsGraphInterval(true);
    setYInterval(selectedDevice?.yInterval ? selectedDevice?.yInterval : 10);
    setXInterval(selectedDevice?.xInterval ? selectedDevice?.xInterval : "10M");

  }

  const handleOpenBlinkModal = () => {
    setIsBlinkPopup(true);
    setBlinkChannel(selectedDevice?.blinkChannel || "");
    setBlinkFunction(selectedDevice?.blinkCondition || ">");
    setBlinkValue(selectedDevice?.blinkValue || "");
    setBlinkFrequency(selectedDevice?.blinkFrequency || 1000);
  }

  const handleProperties = () => {

    setIsBgColor(true);
    setBorderRadius(selectedDevice?.borderRadius || 0);
    setIsTransperant(selectedDevice?.isTransparent ?? false);

  };





  return (
    <>
      <div className={styles.super} onClick={handlePageClick}>
        <div className={styles.wrap}>Dashboard &gt; ViewData &gt; {isPath}</div>
        <div className={styles.newPage}>
          <div className={styles.superWrapper}>
            {/* <Navbar /> */}
            <div className={styles.wrapperRight}>
              {/* <Titlebar title="Project Data" /> */}

              <div className={styles.wrapper} ref={parentDivRef}>
                {/* Saved Widgets */}
                {TempGenerateImage()}

                {TempGenerateDevice({
                  tempTabIndexDevices,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexDevices,
                  indicatorRefs,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  openNewPage,
                  pvSpecificChannel,
                  tableData,
                  clickedDeviceIndex,
                  selectedDevice,
                  currentPVChannel,
                  isMobile,
                  updatedTabIndexDevices,
                })}

                {TempGenerateDisplay({
                  tempTabIndexDisplay,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexDisplay,
                  displayRefs,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexDisplay,
                  multipleDisplay,
                  setMultipleDisplay,
                  openNewPage,
                  tableData,
                  updatedMultipleDisplay,
                  setUpdatedMultipleDisplay
                })}

                {TempGenerateController({
                  tempTabIndexController,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexController,
                  controllerRefs,
                  setCurrentDevice,
                  setIsDeviceMenu,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  images,
                  openNewPage,
                  tabIndexController,
                  setTempTabIndexController,
                  clickedDeviceIndex,
                  selectedDevice,
                  tableData,
                  currentPVController,
                  pvSpecificChannel,
                  currentSVContoller,
                  isMobile,
                  vNetUsername,
                  comid,
                  compvtkey,
                  vNetPassword,
                  key,
                  dispatch,
                  setLoginSid,
                  setIsChangeSV,
                  tempTabIndexIO,
                  setUpdatedTabIndexIO,
                  setTempTabIndexIO,
                  updatedTabIndexController,
                })}

                {TempGenerateIO({
                  tempTabIndexIO,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexIO,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  ioRefs,
                  openNewPage,
                  tabIndexController,
                  clickedDeviceIndex,
                  selectedDevice,
                  tableData,
                  updatedTabIndexIO,
                })}

                {TempGenerateFlowMeter({
                  tempTabIndexFlowM,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexFlowM,
                  flowMRefs,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  openNewPage,
                  images,
                  clickedDeviceIndex,
                  selectedDevice,
                  tableData,
                  pvSpecificChannel,
                  currentPVFlowM,
                  currentSVFlowM,
                  isMobile,
                  updatedTabIndexFlowM,
                })}

                {TempGenerateEnergyNeter({
                  tempTabIndexEnergyM,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexEnergyM,
                  energyMRefs,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  openNewPage,
                  images,
                  clickedDeviceIndex,
                  selectedDevice,
                  tableData,
                  pvSpecificChannel,
                  currentPVEnergyM,
                  currentSVEnergyM,
                  updatedTabIndexEnergyM,
                })}

                {TempGenerateMotor({
                  tempTabIndexMotor,
                  activeTabIndex,
                  isMobile,
                  scaleValue,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexMotor,
                  motorRefs,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexMotor,
                  multipleMotor,
                  setMultipleMotor,
                  updatedMultipleMotor,
                  setUpdatedMultipleMotor
                })}

                {TempGenerateText({
                  tempTabIndexText,
                  activeTabIndex,
                  isMobile,
                  scaleValue,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexText,
                  textRefs,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexText,
                  multipleText,
                  setMultipleText,
                  updatedMultipleText,
                  setUpdatedMultipleText,
                  tableData
                })}

                {TempGenerateLineChart({
                  tempTabIndexLineChart,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexLineChart,
                  lineChartRefs,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexLineChart,
                  multipleLineCharts,
                  setMultipleLineCharts,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexBarChart,
                  openNewPage,
                  selectedDevice,
                  clickedDeviceIndex,
                  data,
                  oneDayDataTs,
                  updatedMultipleLineChart,
                  setUpdatedMultipleLineChart,

                })}

                {TempGeneratePieChart({
                  tempTabIndexPieChart,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexPieChart,
                  pieChartRefs,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexPieChart,
                  multiplePieChart,
                  setMultiplePieChart,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexPieChart,
                  openNewPage,
                  selectedDevice,
                  clickedDeviceIndex,
                  updatedMultiplePieChart,
                  setUpdatedMultiplePieChart,

                })}

                {TempGenerateBarChart({
                  tempTabIndexBarChart,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexBarChart,
                  barChartRefs,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexBarChart,
                  multipleBarChart,
                  setMultipleBarChart,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  setBarChartData,
                  tabIndexBarChart,
                  barChartData,
                  openNewPage,
                  selectedDevice,
                  clickedDeviceIndex,
                  updatedMultipleBarChart,
                  setUpdatedMultipleBarChart,

                })}

                {TempGenerateHistogram({
                  tempTabIndexHistogram,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexHistogram,
                  histogramRefs,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexHistogram,
                  multipleHistogram,
                  setMultipleHistogram,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  setHistogramData,
                  tabIndexBarChart,
                  histogramData,
                  openNewPage,
                  selectedDevice,
                  clickedDeviceIndex,
                  oneDayDataTs,
                  updatedMultipleHistogram,
                  setUpdatedMultipleHistogram,

                })}

                {TempGenerateGauge({
                  tempTabIndexGauge,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexGauge,
                  gaugeRefs,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexGauge,
                  multipleGauge,
                  setMultipleGauge,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexBarChart,
                  openNewPage,
                  selectedDevice,
                  clickedDeviceIndex,
                  specificMaxVal,
                  specificMinVal,
                  changeRange,
                  updatedMultipleGauge,
                  setUpdatedMultipleGauge
                })}

                {TempGenerateProgressBar({
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexProgress,
                  updatedTabIndexProgress,
                  setUpdatedTabIndexProgress,
                  multipleProgress,
                  setMultipleProgress,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  progressBarRefs,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexBarChart,
                  openNewPage,
                  selectedDevice,
                  clickedDeviceIndex,
                  updatedMultipleProgress,
                  setUpdatedMultipleProgress
                })}

                {TempGenerateGrid({
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexGrid,
                  updatedTabIndexGrid,
                  setUpdatedTabIndexGrid,
                  multipleGrid,
                  setMultipleGrid,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  gridRefs,
                  tableData,
                  updatedMultipleGrid,
                  setUpdatedMultipleGrid
                })}

                {TempGenerateTable({
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexTable,
                  updatedTabIndexTable,
                  setUpdatedTabIndexTable,
                  multipleTable,
                  setMultipleTable,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  tableRefs,
                  dateTimesLive,
                  dataArrLive,
                  channelNames,
                  getRandomColor,
                  tabIndexBarChart,
                  openNewPage,
                  selectedDevice,
                  clickedDeviceIndex,
                  updatedMultipleTable,
                  setUpdatedMultipleTable
                })}

                {TempGenerateCircularProgress({
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexCircularProgress,
                  updatedTabIndexCircularProgress,
                  setUpdatedTabIndexCircularProgress,
                  multipleCircularProgress,
                  setMultipleCircularProgress,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  circularProgressRefs,
                  circularProgressData,
                  dateTimesLive,
                  dataArrLive,
                })}

                {TempGenerateDoughnutChart({
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexDoughnut,
                  updatedTabIndexDoughnut,
                  setUpdatedTabIndexDoughnut,
                  multipleDoughnut,
                  setMultipleDoughnut,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  doughnutRefs,
                  dateTimesLive,
                  dataArrLive,
                  getRandomColor,
                })}

                {TempGenerateLines({
                  tempTabIndexLines,
                  selectedTabIndex,
                  isMobile,
                  scaleValue,
                  lineRefs,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  setUpdatedTabIndexLines,
                  tableData,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                })}

                {TempGenerateSquare({
                  tempTabIndexSquare,
                  selectedTabIndex,
                  squareRefs,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexSquare,
                  setUpdatedTabIndexSquare,
                  multipleSquare,
                  setMultipleSquare,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  tableData
                })}

                {TempGenerateCircle({
                  tempTabIndexCircle,
                  selectedTabIndex,
                  circleRefs,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexCircle,
                  setUpdatedTabIndexCircle,
                  multipleCircle,
                  setMultipleCircle,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  tableData
                })}

                {TempGeneratePolygone({
                  tempTabIndexPolygone,
                  setTempTabIndexPolygone,
                  selectedTabIndex,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexPolygone,
                  setUpdatedTabIndexPolygone,
                  multiplePolygone,
                  setMultiplePolygone,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                })}

                {TempGeneratePipe({
                  tempTabIndexPipe,
                  selectedTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  activeTabIndex,
                  setUpdatedTabIndexPipe,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexPipe,
                  multiplePipe,
                  setMultiplePipe,
                  dashOffset,
                  animationRef
                })}

                {TempGenerateSwitch({
                  tempTabIndexSwitch,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexSwitch,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  switchRefs,
                  dataArrLive
                })}

                {TempGenerateCheckbox({
                  tempTabIndexCheckbox,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexCheckbox,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  checkboxRefs,
                  handleSelectCheckbox
                })}

                {TempGenerateRadio({
                  tempTabIndexRadio,
                  activeTabIndex,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexRadio,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  radioRefs,
                  setUpdatedMultipleRadio,
                  updatedMultipleRadio,
                  updatedTabIndexRadio,
                  handleSelectRadioButton
                })}

                {TempGenerateSlider({
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexSlider,
                  updatedTabIndexSlider,
                  setUpdatedTabIndexSlider,
                  multipleSlider,
                  setMultipleSlider,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  sliderRefs,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexBarChart,
                  openNewPage,
                  selectedDevice,
                  clickedDeviceIndex,
                })}

                {TempGenerateLamp({
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexLamp,
                  updatedTabIndexLamp,
                  setUpdatedTabIndexLamp,
                  multipleLamp,
                  setMultipleLamp,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  lampRefs,
                  dateTimesLive,
                  dataArrLive,
                })}

                {TempGeneratePush({
                  tempTabIndexPush,
                  selectedTabIndex,
                  pushRefs,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexPush,
                  setUpdatedTabIndexPush,
                  multiplePush,
                  setMultiplePush,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  handlePushBtnOn,
                  setTempTabIndexPush
                })}

                {TempGenerateLink({
                  tempTabIndexLink,
                  activeTabIndex,
                  isMobile,
                  scaleValue,
                  setClickedDeviceIndex,
                  setSelectedDevice,
                  tempImages,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempImages,
                  setUpdatedImages,
                  setUpdatedTabIndexLink,
                  linkRefs,
                  setIsDeviceMenu,
                  setCurrentDevice,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexLink,
                  multipleLink,
                  setMultipleLink,
                })}

                {TempGenerateClock({
                  tempTabIndexClock,
                  selectedTabIndex,
                  clockRefs,
                  setSelectedDeviceId,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedTabIndexClock,
                  setUpdatedTabIndexClock,
                  multipleClock,
                  setMultipleClock,
                  updatedImages,
                  setIndexesOfDevicePosi,
                  indexesOfDevicePosi,
                  setTempTabIndexClock
                })}

                {/* New Widgets */}

                {multipleImages.map((image, imgIndex) => {
                  const deviceType = "Image"
                  const imagePositions = imagePosition[imgIndex];
                  const imageStyle = {
                    resize: 'both',
                    width: '100px',
                    height: '100px',
                    zIndex: image?.zIndex ?? "1"
                  };
                  return (
                    <Draggble
                      onStop={(e, data) =>
                        handleDragStop(e, data, imgIndex, setImagePosition)
                      }
                      position={imagePositions}
                      bounds="parent"
                    >
                      <div
                        className={`${styles.imgToDisplay} ${styles.addImg}`}
                        id={`displayImage-${imgIndex}`}
                        style={imageStyle}
                        onContextMenu={(e) => {
                          getDimensions(e, imgIndex, setImageDimensions);
                          HandleDeleteContextMenu(e, imgIndex, deviceType, image);
                        }}
                      >
                        <img src={image.name} alt="" className={styles.addImg} />
                      </div>
                    </Draggble>
                  );
                })}

                {GenerateNewDisplay({
                  multipleDisplay,
                  activeTabIndex,
                  setDisplayPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexDisplay,
                  updatedTabIndexDisplay,
                  setUpdatedTabIndexDisplay,
                  setMultipleDisplay,
                  tableData,
                  pvSpecificChannel,
                  openNewPage,
                  currentPVChannel,
                  setCurrentPVChannel,
                  updatedMultipleDisplay,
                  setUpdatedMultipleDisplay
                })}

                {GenerateNewIndicatores({
                  multipleDevices,
                  activeTabIndex,
                  setDevicePosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tableData,
                  pvSpecificChannel,
                  openNewPage,
                  currentPVChannel,
                  setCurrentPVChannel,
                })}

                {GenerateNewController({
                  multipleController,
                  activeTabIndex,
                  setControllerPosition,
                  newControllerRefs,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tableData,
                  svControllerChannel,
                  pvControllerChannel,
                  setMultipleController,
                  currentPVController,
                  currentSVContoller,
                })}

                {GenerateNewIO({
                  multipleIO,
                  activeTabIndex,
                  setIOPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexIO,
                  updatedTabIndexIO,
                  setUpdatedTabIndexIO,
                  setMultipleIO,
                  tableData
                })}

                {GenerateNewFlowMeter({
                  multipleFlowM,
                  activeTabIndex,
                  setFlowMPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tableData,
                  currentPVFlowM,
                  currentSVFlowM,
                  pvFlowMChannels,
                  svFlowMChannels,
                })}

                {GenerateNewEnergyMeter({
                  multipleEnergyM,
                  activeTabIndex,
                  setEnergyMPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tableData,
                  currentPVEnergyM,
                  currentSVEnergyM,
                  pvEnergyMChannels,
                  svEnergyMChannels,
                })}

                {GenerateNewText({
                  multipleText,
                  activeTabIndex,
                  setTextPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexText,
                  updatedTabIndexText,
                  setUpdatedTabIndexText,
                  setMultipleText,
                  updatedMultipleText,
                  setUpdatedMultipleText,
                  tableData
                })}

                {GenerateNewMotor({
                  setMotorPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexMotor,
                  updatedTabIndexMotor,
                  setUpdatedTabIndexMotor,
                  multipleMotor,
                  setMultipleMotor,
                  updatedMultipleMotor,
                  setUpdatedMultipleMotor
                })}

                {GenerateNewLineChart({
                  setLineChartPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexLineChart,
                  updatedTabIndexLineChart,
                  setUpdatedTabIndexLineChart,
                  multipleLineCharts,
                  setMultipleLineCharts,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexPieChart,
                  openNewPage,
                  data,
                  endHours,
                  endMinutes,
                  oneDayDataTs,
                  updatedMultipleLineChart,
                  setUpdatedMultipleLineChart,

                })}

                {GenerateNewPieChart({
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexPieChart,
                  updatedTabIndexPieChart,
                  setUpdatedTabIndexPieChart,
                  multiplePieChart,
                  setMultiplePieChart,
                  setPieChartPosition,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexPieChart,
                  openNewPage,
                  pieChartChannels,
                  updatedMultiplePieChart,
                  setUpdatedMultiplePieChart,

                })}

                {GenerateNewBarChart({
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexBarChart,
                  updatedTabIndexBarChart,
                  setUpdatedTabIndexBarChart,
                  multipleBarChart,
                  setMultipleBarChart,
                  setBarChartPosition,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexPieChart,
                  openNewPage,
                  pieChartChannels,
                  updatedMultipleBarChart,
                  setUpdatedMultipleBarChart,

                })}

                {GenerateNewHistogram({
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexHistogram,
                  updatedTabIndexHistogram,
                  setUpdatedTabIndexHistogram,
                  multipleHistogram,
                  setMultipleHistogram,
                  setHistogramPosition,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexPieChart,
                  openNewPage,
                  endHours,
                  endMinutes,
                  oneDayDataTs,
                  updatedMultipleHistogram,
                  setUpdatedMultipleHistogram,

                })}

                {GenerateNewGauge({
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexGauge,
                  updatedTabIndexGauge,
                  setUpdatedTabIndexGauge,
                  multipleGauge,
                  setMultipleGauge,
                  setGaugePosition,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexPieChart,
                  openNewPage,
                  startPoint,
                  endPoint,
                  updatedMultipleGauge,
                  setUpdatedMultipleGauge
                })}

                {GenerateNewProgressbar({
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexProgress,
                  updatedTabIndexProgress,
                  setUpdatedTabIndexProgress,
                  multipleProgress,
                  setMultipleProgress,
                  setProgressPosition,
                  rotateBar,
                  dateTimesLive,
                  channelNames,
                  dataArrLive,
                  getRandomColor,
                  tabIndexPieChart,
                  openNewPage,
                  updatedMultipleProgress,
                  setUpdatedMultipleProgress
                })}

                {GenarateNewTable({
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexTable,
                  updatedTabIndexTable,
                  setUpdatedTabIndexTable,
                  multipleTable,
                  setMultipleTable,
                  setTablePosition,
                  channelNames,
                  dataArrLive,
                  updatedMultipleTable,
                  setUpdatedMultipleTable
                })}

                {GenerateNewGrid({
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  activeTabIndex,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexGrid,
                  updatedTabIndexGrid,
                  setUpdatedTabIndexGrid,
                  multipleGrid,
                  setMultipleGrid,
                  setGridPosition,
                  tableData,
                  updatedMultipleGrid,
                  setUpdatedMultipleGrid
                })}

                {GenerateNewCircularProgress({
                  multipleCircularProgress,
                  activeTabIndex,
                  setCircularProgressPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  tempTabIndexCircularProgress,
                  updatedTabIndexCircularProgress,
                  setMultipleCircularProgress,
                  setUpdatedTabIndexCircularProgress,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  setSelectedDeviceId,
                  updatedMultipleCircularProgress,
                  setUpdatedMultipleCircularProgress,
                  dateTimesLive,
                  dataArrLive,
                })}

                {GenerateNewDoughnutChart({
                  multipleDoughnut,
                  activeTabIndex,
                  setDoughnutPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  tempTabIndexDoughnut,
                  updatedTabIndexDoughnut,
                  setMultipleDoughnut,
                  setUpdatedTabIndexDoughnut,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  setSelectedDeviceId,
                  setUpdatedMultipleDoughnut,
                  updatedMultipleDoughnut,
                  dateTimesLive,
                  dataArrLive,
                  getRandomColor,
                })}

                {GenerateNewLines({
                  multipleLines,
                  activeTabIndex,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tableData,
                  setLinePosition,

                })}

                {GenerateNewSquare({
                  multipleSquare,
                  activeTabIndex,
                  setSquarePosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexSquare,
                  updatedTabIndexSquare,
                  setUpdatedTabIndexSquare,
                  setMultipleSquare,
                  updatedMultipleSquare,
                  setUpdatedMultipleSquare,
                  tableData
                })}

                {GenerateNewCircle({
                  multipleCircle,
                  activeTabIndex,
                  setSquarePosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexCircle,
                  updatedTabIndexCircle,
                  setUpdatedTabIndexCircle,
                  updatedMultipleCircle,
                  setUpdatedMultipleCircle,
                  setMultipleCircle,
                  setCirclePosition,
                  tableData
                })}

                {GenerateNewPolygon({
                  multiplePolygone,
                  activeTabIndex,
                  setPolygonePosition,
                  setUpdatedMultiplePolygone,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  updatedMultiplePolygone,
                  setMultiplePolygone
                })}

                {GenerateNewPipe({
                  multiplePipe,
                  setPipePosition,
                  setUpdatedMultiplePipe,
                  activeTabIndex,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  dashOffset
                })}

                {GenerateNewSwitch({
                  multipleSwitch,
                  activeTabIndex,
                  setSwitchPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexSwitch,
                  updatedTabIndexSwitch,
                  setUpdatedTabIndexSwitch,
                  updatedMultipleSwitch,
                  setUpdatedMultipleSwitch,
                  setMultipleSwitch,
                  dataArrLive
                })}

                {GenerateNewCheckbox({
                  multipleCheckbox,
                  activeTabIndex,
                  setCheckboxPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexCheckbox,
                  updatedTabIndexCheckbox,
                  setUpdatedTabIndexCheckbox,
                  updatedMultipleCheckbox,
                  setUpdatedMultipleCheckbox,
                  setMultipleCheckbox,
                  handleSelectCheckbox
                })}

                {GenerateNewRadio({
                  multipleRadio,
                  activeTabIndex,
                  setRadioPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexRadio,
                  updatedTabIndexRadio,
                  setUpdatedTabIndexRadio,
                  updatedMultipleRadio,
                  setUpdatedMultipleRadio,
                  setMultipleRadio,
                  handleSelectRadioButton
                })}

                {GenerateNewSlider({
                  multipleSlider,
                  activeTabIndex,
                  setSliderPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexSlider,
                  updatedTabIndexSlider,
                  setUpdatedTabIndexSlider,
                  updatedMultipleSlider,
                  setUpdatedMultipleSlider,
                  setMultipleSlider,
                  dataArrLive,
                  dateTimesLive

                })}

                {GenerateNewLamp({
                  multipleLamp,
                  activeTabIndex,
                  setLampPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexLamp,
                  updatedTabIndexLamp,
                  setUpdatedTabIndexLamp,
                  updatedMultipleLamp,
                  setUpdatedMultipleLamp,
                  tableData
                })}

                {GenerateNewPush({
                  multiplePush,
                  activeTabIndex,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexPush,
                  updatedTabIndexPush,
                  setUpdatedTabIndexPush,
                  updatedMultiplePush,
                  setUpdatedMultiplePush,
                  setMultiplePush,
                  setPushPosition
                })}

                {GenerateNewLink({
                  multipleLink,
                  activeTabIndex,
                  setLinkPosition,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexLink,
                  updatedTabIndexLink,
                  setUpdatedTabIndexLink,
                  setMultipleLink,
                  updatedMultipleLink,
                  setUpdatedMultipleLink
                })}

                {GenerateNewClock({
                  multipleClock,
                  activeTabIndex,
                  setDeviceMenuPosition,
                  setClickedDeviceIndex,
                  setIsDeviceMenu,
                  setSelectedDevice,
                  setCurrentDevice,
                  tempImages,
                  setTempImages,
                  setUpdatedImages,
                  setAddedText,
                  setBgColor,
                  setTextBgColor,
                  setTextColor,
                  setWidgetTextColor,
                  setFontSize,
                  setTextFontSize,
                  setTextAlignVertically,
                  setTextAlignHorizontally,
                  tempTabIndexClock,
                  updatedTabIndexClock,
                  setUpdatedTabIndexClock,
                  updatedMultipleClock,
                  setUpdatedMultipleClock,
                  setMultipleClock,
                  setClockPosition
                })}

                {isDrawing && (
                  <canvas
                    ref={lineCanvasRef}
                    width={parentDivRef.current.getBoundingClientRect()?.width || window.innerWidth}
                    height={parentDivRef.current.getBoundingClientRect()?.height || window.innerHeight}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      zIndex: 1000,
                      background: 'transparent', // Transparent background
                      cursor: 'crosshair',
                    }}
                    onMouseDown={handleLineMouseDown}
                    onMouseMove={handleLineMouseMove}
                    onMouseUp={handleLineMouseUp}
                  />
                )}

                {isPolygoneStage && (
                  <PolygonDrawer
                    points={points}
                    setPoints={setPoints}
                    isPolygoneComplete={isPolygoneComplete}
                    setIsPolygoneComplete={setIsPolygoneComplete}
                    setIsPolygoneStage={setIsPolygoneStage}
                    activeTabIndex={activeTabIndex}
                    setMultiplePolygone={setMultiplePolygone}
                    setUpdatedMultiplePolygone={setUpdatedMultiplePolygone}

                  />
                )}

                {isPipeStage && (
                  <PipeDrawer
                    points={points}
                    setPoints={setPoints}
                    setMultiplePipe={setMultiplePipe}
                    setIsPipeStage={setIsPipeStage}
                    activeTabIndex={activeTabIndex}
                  />
                )}

                <Tabs
                  isFitted
                  size="sm"
                  variant="enclosed"
                  defaultIndex={selectedTabIndex}
                >
                  <div className={styles.tabList}>
                    <TabList
                      style={
                        isMobile
                          ? {
                            border: 'none',
                            display: 'flex',
                            flexWrap: 'wrap',
                          }
                          : { border: 'none' }
                      }
                    >
                      {tempTabNames.map((name, tabIndex) => (
                        <Tab
                          id="selectedTab"
                          key={tabIndex}
                          style={{ border: 'none' }}
                          onContextMenu={(event) =>
                            handleContextMenu(event, tabIndex, name)
                          }
                          onClick={() => handleTabClick(tabIndex, name)}
                        >
                          <p id="clickedTab">{name}</p>
                        </Tab>
                      ))}
                      <button
                        onClick={handleAddNewTab}
                        className={styles.addNewTagBtn}
                      >
                        <AiOutlinePlus /> New Tab
                      </button>
                    </TabList>
                    <div className={styles.gridBg}></div>
                  </div>
                  <TabPanels>
                    <TabPanel>
                      <Overview
                        uniqueProjectId={uniqueProjectId}
                        data={data}
                        socketData={socketData}
                        openNewPage={openNewPage}
                        handleOverviewInfoDrop={handleOverviewInfoDrop}
                        handleOverviewGraphDrop={handleOverviewGraphDrop}
                        tabIndexOverviewInfo={tabIndexOverviewInfo}
                        selectedTabIndex={activeTabIndex}
                        tabIndexOverviewGraph={tabIndexOverviewGraph}
                        handleOverviewGraphDimension={
                          handleOverviewGraphDimension
                        }
                        tempTabIndexOverviewInfo={tempTabIndexOverviewInfo}
                        tempTabIndexOverviewGraph={tempTabIndexOverviewGraph}
                        isMobile={isMobile}
                        scaleValue={scaleValue}
                        setOverviewInfoPosi={setOverviewInfoPosi}
                        tempImages={tempImages}
                        setTempImages={setTempImages}
                        setUpdatedImages={setUpdatedImages}
                        setOverviewGraphPosi={setOverviewGraphPosi}
                        setOverviewGraphDimension={setOverviewGraphDimension}
                      />
                    </TabPanel>
                    <TabPanel style={{ height: '68vh' }}>
                      <Channels
                        data={data}
                        socketData={socketData}
                        handleDefaultGridDimension={handleDefaultGridDimension}
                        handleDefaultGridDrop={handleDefaultGridDrop}
                        openNewPage={openNewPage}
                        selectedTabIndex={activeTabIndex}
                        tabIndexDefaultGrid={tabIndexDefaultGrid}
                        tempTabIndexDefaultGrid={tempTabIndexDefaultGrid}
                        setDefaultGridPosi={setDefaultGridPosi}
                        isMobile={isMobile}
                        scaleValue={scaleValue}
                        tempImages={tempImages}
                        setTempImages={setTempImages}
                        setUpdatedImages={setUpdatedImages}
                      />
                    </TabPanel>
                    <TabPanel style={{ height: '68vh' }}>
                      <LiveData
                        uniqueProjectId={uniqueProjectId}
                        data={data}
                        socketData={socketData}
                        openNewPage={openNewPage}
                        selectedTabIndex={activeTabIndex}
                        tabIndexLiveDataGraph={tabIndexLiveDataGraph}
                        setTabIndexLiveDataGraph={setTabIndexLiveDataGraph}
                        handleLiveDataGraphDrop={handleLiveDataGraphDrop}
                        handleLiveDataDimension={handleLiveDataDimension}
                        tempTabIndexLiveDataGraph={tempTabIndexLiveDataGraph}
                        isMobile={isMobile}
                        scaleValue={scaleValue}
                        setLiveDataGraphPosi={setLiveDataGraphPosi}
                        setLiveDataGraphDimension={setLiveDataGraphDimension}
                        tempImages={tempImages}
                        setTempImages={setTempImages}
                        setUpdatedImages={setUpdatedImages}
                      />
                    </TabPanel>
                    <TabPanel>
                      <Day1
                        data={data}
                        socketData={socketData}
                        tabIndexLastDayTable={tabIndexLastDayTable}
                        tabIndexLastDayGraph={tabIndexLastDayGraph}
                        handleLastDayTableDrop={handleLastDayTableDrop}
                        selectedTabIndex={activeTabIndex}
                        openNewPage={openNewPage}
                        handleLastDayTableDimension={
                          handleLastDayTableDimension
                        }
                        handleLastDayGraphDrop={handleLastDayGraphDrop}
                        handleLastDayGraphDimension={
                          handleLastDayGraphDimension
                        }
                        tempTabIndexLastDayGraph={tempTabIndexLastDayGraph}
                        tempTabIndexLastDayTable={tempTabIndexLastDayTable}
                        scaleValue={scaleValue}
                        isMobile={isMobile}
                        setLastDayGraphPosi={setLastDayGraphPosi}
                        tempImages={tempImages}
                        setTempImages={setTempImages}
                        setUpdatedImages={setUpdatedImages}
                        setLastDayGraphDimension={setLastDayGraphDimension}
                        setDefaultGridPosi={setDefaultGridPosi}
                        setDefaultGridDimension={setDefaultGridDimension}
                        setLastDayTablePosi={setLastDayTablePosi}
                        setLastDayTableDimension={setLastDayTableDimension}
                      />
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </div>
            </div>
          </div>
          <ToolBar
            setDisplayImage={setDisplayImage}
            multipleImages={multipleImages}
            setMultipleImages={setMultipleImages}
            tempImages={tempImages}
            setTempImages={setTempImages}
            setActiveTabIndex={setActiveTabIndex}
            activeTabIndex={activeTabIndex}
            setStoreTabIndexes={setStoreTabIndexes}
            storeTabIndexes={storeTabIndexes}
            setMultipleDevices={setMultipleDevices}
            multipleDevices={multipleDevices}
            setTabIndexForDevices={setTabIndexForDevices}
            tabIndexForDevice={tabIndexForDevice}
            setMultipleController={setMultipleController}
            multipleController={multipleController}
            multipleIO={multipleIO}
            setMultipleIO={setMultipleIO}
            setMultipleFlowM={setMultipleFlowM}
            multipleFlowM={multipleFlowM}
            multipleEnergyM={multipleEnergyM}
            setMultipleEnergyM={setMultipleEnergyM}
            multipleLineCharts={multipleLineCharts}
            setMultipleLineCharts={setMultipleLineCharts}
            setMultiplePieChart={setMultiplePieChart}
            multiplePieChart={multiplePieChart}
            multipleBarChart={multipleBarChart}
            setMultipleBarChart={setMultipleBarChart}
            multipleHistogram={multipleHistogram}
            setMultipleHistogram={setMultipleHistogram}
            multipleGauge={multipleGauge}
            setMultipleGauge={setMultipleGauge}
            setMultipleProgress={setMultipleProgress}
            multipleProgress={multipleProgress}
            setCurrentPVChannel={setCurrentPVChannel}
            setMultipleGrid={setMultipleGrid}
            multipleGrid={multipleGrid}
            multipleTable={multipleTable}
            setMultipleTable={setMultipleTable}
            updatedMultipleDevices={updatedMultipleDevices}
            setUpdatedMultipleDevices={setUpdatedMultipleDevices}
            updatedMultipleController={updatedMultipleController}
            setUpdatedMultipleController={setUpdatedMultipleController}
            updatedMultipleIO={updatedMultipleIO}
            setUpdatedMultipleIO={setUpdatedMultipleIO}
            updatedMultipleFLowM={updatedMultipleFlowM}
            setUpdatedMultipleFlowM={setUpdatedMultipleFlowM}
            updatedMultipleEnergyM={updatedMultipleEnergyM}
            setUpdatedMultipleEnergyM={setUpdatedMultipleEnergyM}
            updatedMultipleLineChart={updatedMultipleLineChart}
            setUpdatedMultipleLineChart={setUpdatedMultipleLineChart}
            updatedMultiplePieChart={updatedMultiplePieChart}
            setUpdatedMultiplePieChart={setUpdatedMultiplePieChart}
            updatedMultipleBarChart={updatedMultipleBarChart}
            setUpdatedMultipleBarChart={setUpdatedMultipleBarChart}
            updatedMultipleHistogram={updatedMultipleHistogram}
            setUpdatedMultipleHistogram={setUpdatedMultipleHistogram}
            updatedMultipleGauge={updatedMultipleGauge}
            setUpdatedMultipleGauge={setUpdatedMultipleGauge}
            updatedMultipleProgress={updatedMultipleProgress}
            setUpdatedMultipleProgress={setUpdatedMultipleProgress}
            updatedMultipleGrid={updatedMultipleGrid}
            setUpdatedMultipleGrid={setUpdatedMultipleGrid}
            updatedMultipleTable={updatedMultipleTable}
            setUpdatedMultipleTable={setUpdatedMultipleTable}
            multipleMotor={multipleMotor}
            setMultipleMotor={setMultipleMotor}
            updatedMultipleMotor={updatedMultipleMotor}
            setUpdatedMultipleMotor={setUpdatedMultipleMotor}
            isMotorOptions={isMotorOptions}
            setIsMotorOptions={setIsMotorOptions}
            isDeviceOption={isDeviceOption}
            setIsDeviceOption={setIsDeviceOption}
            multipleDisplay={multipleDisplay}
            setMultipleDisplay={setMultipleDisplay}
            updatedMultipleDisplay={updatedMultipleDisplay}
            setUpdatedMultipleDisplay={setUpdatedMultipleDisplay}
            multipleText={multipleText}
            setMultipleText={setMultipleText}
            updatedMultipleText={updatedMultipleText}
            setUpdatedMultipleText={setUpdatedMultipleText}
            multipleCircularProgress={multipleCircularProgress}
            setMultipleCircularProgress={setMultipleCircularProgress}
            updatedMultipleCircularProgress={updatedMultipleCircularProgress}
            setUpdatedMultipleCircularProgress={
              setUpdatedMultipleCircularProgress
            }
            multipleDoughnut={multipleDoughnut}
            setMultipleDoughnut={setMultipleDoughnut}
            updatedMultipleDoughnut={updatedMultipleDoughnut}
            setUpdatedMultipleDoughnut={setUpdatedMultipleDoughnut}
            isDrawingObjects={isDrawingObjects}
            setIsDrawingObjects={setIsDrawingObjects}
            setIsDrawing={setIsDrawing}
            multipleSquare={multipleSquare}
            setMultipleSquare={setMultipleSquare}
            setUpdatedMultipleSquare={setUpdatedMultipleSquare}
            updatedMultipleSquare={updatedMultipleSquare}
            setMultipleCircle={setMultipleCircle}
            multipleCircle={multipleCircle}
            setUpdatedMultipleCircle={setUpdatedMultipleCircle}
            updatedMultipleCircle={updatedMultipleCircle}
            setIsPolygoneStage={setIsPolygoneStage}
            setIsPipeStage={setIsPipeStage}
            isGraphOptions={isGraphOptions}
            setIsGraphOptions={setIsGraphOptions}
            multipleSwitch={multipleSwitch}
            setMultipleSwitch={setMultipleSwitch}
            updatedMultipleSwitch={updatedMultipleSwitch}
            setUpdatedMultipleSwitch={setUpdatedMultipleSwitch}
            setIsBtnOptions={setIsBtnOptions}
            multipleCheckbox={multipleCheckbox}
            setMultipleCheckbox={setMultipleCheckbox}
            updatedMultipleCheckbox={updatedMultipleCheckbox}
            setUpdatedMultipleCheckbox={setUpdatedMultipleCheckbox}
            isBtnOptions={isBtnOptions}
            multipleRadio={multipleRadio}
            setMultipleRadio={setMultipleRadio}
            updatedMultipleRadio={updatedMultipleRadio}
            setUpdatedMultipleRadio={setUpdatedMultipleRadio}
            multipleSlider={multipleSlider}
            setMultipleSlider={setMultipleSlider}
            updatedMultipleSlider={updatedMultipleSlider}
            setUpdatedMultipleSlider={setUpdatedMultipleSlider}
            multipleLamp={multipleLamp}
            setMultipleLamp={setMultipleLamp}
            updatedMultipleLamp={updatedMultipleLamp}
            setUpdatedMultipleLamp={setUpdatedMultipleLamp}
            multiplePush={multiplePush}
            setMultiplePush={setMultiplePush}
            updatedMultiplePush={updatedMultiplePush}
            setUpdatedMultiplePush={setUpdatedMultiplePush}
            multipleLink={multipleLink}
            setMultipleLink={setMultipleLink}
            updatedMultipleLink={updatedMultipleLink}
            setUpdatedMultipleLink={setUpdatedMultipleLink}
            multipleClock={multipleClock}
            setMultipleClock={setMultipleClock}
            updatedMultipleClock={updatedMultipleClock}
            setUpdatedMultipleClock={setUpdatedMultipleClock}

          />

          <button className={styles.discardBtn} onClick={handleDiscardPage}>
            Discard
          </button>
          <button className={styles.closeButton} onClick={handleClosePage}>
            Close
          </button>
          <button
            className={styles.floppyDisk}
            onClick={() =>
              SaveView({
                indexesToRaname,
                RenameInputValues,
                tempTabNames,
                widgetsData,
                multipleImages,
                storeTabIndexes,
                imagePosition,
                imageDimensions,
                tempImages,
                updatedImages,
                displayData,
                multipleDisplay,
                displayPosition,
                deviceData,
                multipleDevices,
                devicePosition,
                controllerData,
                multipleController,
                controllerPosition,
                ioData,
                multipleIO,
                updatedMultipleIO,
                ioPosition,
                flowMeterData,
                multipleFlowM,
                flowMPosition,
                energyMeterData,
                multipleEnergyM,
                energyMPosition,
                textData,
                multipleText,
                textPosition,
                textAlignVertically,
                textAlignHorizontally,
                motorData,
                multipleMotor,
                motorPosition,
                lineChartData,
                multipleLineCharts,
                lineChartPosition,
                pieChartData,
                multiplePieChart,
                pieChartPosition,
                toolbarChartData,
                multipleBarChart,
                barChartPosition,
                toolBarhistogramData,
                multipleHistogram,
                histogramPosition,
                gaugeData,
                multipleGauge,
                gaugePosition,
                startPoint,
                endPoint,
                setImages,
                progressBarData,
                multipleProgress,
                progressPosition,
                minimumVal,
                maximumVal,
                rotateBar,
                gridData,
                multipleGrid,
                gridPositions,
                toolBarTableData,
                multipleTable,
                tablePosition,
                tabIndexOverviewInfo,
                overviewInfoData,
                overviewInfoPosi,
                tabIndexOverviewGraph,
                overviewGraphData,
                overviewGraphPosi,
                overviewGraphDimension,
                tabIndexLiveDataGraph,
                liveGraphData,
                liveDataGraphPosi,
                liveDataGraphDimension,
                tabIndexLastDayTable,
                lastDayTableData,
                lastDayTablePosi,
                lastDayTableDimension,
                tabIndexLastDayGraph,
                lastDayGraphData,
                lastDayGraphPosi,
                lastDayGraphDimension,
                tabIndexDefaultGrid,
                defaultGridData,
                defaultGridPosi,
                defaultGridDimension,
                removeDuplicates,
                dispatch,
                addWidget,
                windowHeight,
                windowWidth,
                uniqueProjectId,
                toast,
                setUpdatedImages,
                setTempTabIndexDevices,
                setMultipleDevices,
                setTempTabIndexDisplay,
                setMultipleDisplay,
                setTempTabIndexController,
                setMultipleController,
                setTempTabIndexIO,
                setMultipleIO,
                setTempTabIndexFlowM,
                setMultipleFlowM,
                setTempTabIndexEnergyM,
                setMultipleEnergyM,
                setTempTabIndexMotor,
                setMultipleMotor,
                setTempTabIndexText,
                setMultipleText,
                setTempTabIndexLineChart,
                setMultipleLineCharts,
                setTempTabIndexPieChart,
                setMultiplePieChart,
                setTempTabIndexBarChart,
                setMultipleBarChart,
                setTempTabIndexHistogram,
                setMultipleHistogram,
                setTempTabIndexGauge,
                setMultipleGauge,
                setTempTabIndexProgress,
                setMultipleProgress,
                setTempTabIndexGrid,
                setMultipleGrid,
                setTempTabIndexTable,
                setMultipleTable,
                setTabIndexImages,
                setTabIndexDevices,
                setUpdatedTabIndexDevices,
                setTabIndexDisplay,
                setUpdatedTabIndexDisplay,
                setTabIndexController,
                setUpdatedTabIndexController,
                setTabIndexIO,
                setUpdatedTabIndexIO,
                setTabIndexFlowM,
                setUpdatedTabIndexFlowM,
                setTabIndexEnergyM,
                setUpdatedTabIndexEnergyM,
                setTabIndexMotor,
                setUpdatedTabIndexMotor,
                setTabIndexText,
                setUpdatedTabIndexText,
                setTabIndexLineChart,
                setUpdatedTabIndexLineChart,
                setTabIndexPieChart,
                setUpdatedTabIndexPieChart,
                setTabIndexBarChart,
                setUpdatedTabIndexBarChart,
                setTabIndexHistogram,
                setUpdatedTabIndexHistogram,
                setTabIndexGauge,
                setUpdatedTabIndexGauge,
                setTabIndexProgress,
                setUpdatedTabIndexProgress,
                setTabIndexGrid,
                setUpdatedTabIndexGrid,
                setTabIndexTable,
                setUpdatedTabIndexTable,
                setTabIndexOverviewGraph,
                setTabIndexOverviewInfo,
                setTabIndexLiveDataGraph,
                setTabIndexLastDayTable,
                setTabIndexLastDayGraph,
                setTabIndexDefaultGrid,
                multipleCircularProgress,
                setMultipleCircularProgress,
                updatedMultipleCircularProgress,
                setUpdatedMultipleCircularProgress,
                tempTabIndexCircularProgress,
                setTempTabIndexCircularProgress,
                updatedTabIndexCircularProgress,
                setUpdatedTabIndexCircularProgress,
                circularProgressData,
                circularProgressPosition,
                setTabIndexCircularProgress,
                updatedMultipleDisplay,
                updatedMultipleText,
                updatedMultipleMotor,
                updatedMultipleLineChart,
                updatedMultiplePieChart,
                updatedMultipleBarChart,
                updatedMultipleHistogram,
                updatedMultipleGauge,
                updatedMultipleProgress,
                updatedMultipleGrid,
                updatedMultipleTable,
                multipleDoughnut,
                setTabIndexDoughnut,
                setUpdatedTabIndexDoughnut,
                doughnutData,
                setTempTabIndexDoughnut,
                setMultipleDoughnut,
                doughnutPosition,
                updatedMultipleDoughnut,
                linesData,
                multipleLines,
                setTempTabIndexLines,
                setMultipleLines,
                setTabIndexLines,
                setUpdatedTabIndexLines,
                updatedMultipleSquare,
                squarePosition,
                multipleSquare,
                squareData,
                setTabIndexSquare,
                setUpdatedTabIndexSquare,
                setMultipleSquare,
                setTempTabIndexSquare,
                setUpdatedTabIndexCircle,
                setTabIndexCircle,
                setTempTabIndexCircle,
                circleData,
                updatedMultipleCircle,
                circlePosition,
                setMultipleCircle,
                multipleCircle,
                polygoneData,
                multiplePolygone,
                setMultiplePolygone,
                updatedMultiplePolygone,
                setUpdatedMultiplePolygone,
                polygonePosition,
                setTabIndexPolygone,
                setUpdatedTabIndexPolygone,
                setTempTabIndexPolygone,
                pipeData,
                multiplePipe,
                setMultiplePipe,
                updatedMultiplePipe,
                pipePosition,
                setTabIndexPipe,
                setUpdatedTabIndexPipe,
                setTempTabIndexPipe,
                switchData,
                multipleSwitch,
                setMultipleSwitch,
                updatedMultipleSwitch,
                switchPosition,
                setTabIndexSwitch,
                setUpdatedTabIndexSwitch,
                setTempTabIndexSwitch,
                checkboxData,
                multipleCheckbox,
                setMultipleCheckbox,
                checkboxPosition,
                setTabIndexCheckbox,
                setUpdatedTabIndexCheckbox,
                setTempTabIndexCheckbox,
                radioData,
                multipleRadio,
                setMultipleRadio,
                radioPosition,
                setTabIndexRadio,
                setUpdatedTabIndexRadio,
                setTempTabIndexRadio,
                updatedMultipleRadio,
                sliderData,
                multipleSlider,
                setMultipleSlider,
                sliderPosition,
                setTabIndexSlider,
                setUpdatedTabIndexSlider,
                setTempTabIndexSlider,
                updatedMultipleSlider,
                lampData,
                multipleLamp,
                setMultipleLamp,
                lampPosition,
                setTabIndexLamp,
                setUpdatedTabIndexLamp,
                setTempTabIndexLamp,
                updatedMultipleLamp,
                pushData,
                multiplePush,
                setMultiplePush,
                pushPosition,
                setTabIndexPush,
                setUpdatedTabIndexPush,
                setTempTabIndexPush,
                updatedMultiplePush,
                linkData,
                multipleLink,
                setMultipleLink,
                linkPosition,
                setTabIndexLink,
                setUpdatedTabIndexLink,
                setTempTabIndexLink,
                updatedMultipleLink,
                clockData,
                multipleClock,
                setMultipleClock,
                clockPosition,
                setTabIndexClock,
                setUpdatedTabIndexClock,
                setTempTabIndexClock,
                updatedMultipleClock,
                onText,
                offText,
                onColor,
                offColor,
                linePosition,
                containerDimensions
                

              })
            }
          >
            <img src={floopyDisk} alt="" className={styles.floppyDiskImg} />
          </button>
          {deleteContextMenu && (
            <div
              className={styles.deleteContextMenu}
              style={{
                top: deleteContextPosi.y,
                left: deleteContextPosi.x,
                boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
              }}
            >
              <button
                className={styles.deleteImage}
                onClick={
                  multipleImages.length > 0
                    ? () =>
                      handleNewDeleteImage({
                        setDeleteContextMenu,
                        multipleImages,
                        clickedImgIndex,
                        setMultipleImages,
                      })
                    : () =>
                      handleSavedDeleteImage({
                        setDeleteContextMenu,
                        tempTabIndexImages,
                        activeTabIndex,
                        selectedImg,
                        setTempTabIndexImages,
                        images,
                        tempImages,
                        setTempImages,
                        setIndexesToDeleteImg,
                        indexesToDeleteImg,
                        imagesRefs,
                      })
                }
              >
                Delete
              </button>

              <button
                className={styles.rangeBtn}
                onClick={() => setIsHidePopup(true)}
              >
                Hide
              </button>

              <button
                className={styles.rangeBtn}
                onClick={(e) => handleHorizontalMoveClick(e)}

              >
                Horizontal Movement
              </button>

              <button
                className={styles.rangeBtn}
                onClick={(e) => handleVerticalMoveClick(e)}

              >
                Vertical Movement
              </button>

              <button className={styles.rangeBtn} onMouseEnter={(e) => handleMouseEnter(e)}>
                Position &gt;
              </button>

              {isSubMenu && (
                <div className={styles.subMenu} style={{ top: subMenuPosi.y, left: subMenuPosi.x + 10 }}>
                  <button
                    onClick={() => WidgetZIndexChange({
                      action: "SendBack",
                      setIsSubMenu,
                      currentDevice,
                      tempTabIndexSquare,
                      tempTabIndexCircle,
                      activeTabIndex,
                      selectedDevice,
                      clickedDeviceIndex,
                      tempImages,
                      setTempImages,
                      setUpdatedImages,
                      multipleSquare,
                      setMultipleSquare,
                      multipleCircle,
                      setMultipleCircle,
                      tempTabIndexImages,
                      multipleImages,
                      setMultipleImages,
                      tempTabIndexDisplay,
                      multipleDisplay,
                      setMultipleDisplay,
                      tempTabIndexDevices,
                      multipleDevices,
                      setMultipleDevices,
                      tempTabIndexController,
                      multipleController,
                      setMultipleController,
                      tempTabIndexFlowM,
                      multipleFlowM,
                      setMultipleFlowM,
                      tempTabIndexEnergyM,
                      multipleEnergyM,
                      setMultipleEnergyM,
                      tempTabIndexMotor,
                      multipleMotor,
                      setMultipleMotor,
                      tempTabIndexText,
                      multipleText,
                      setMultipleText,
                      tempTabIndexLineChart,
                      multipleLineCharts,
                      setMultipleLineCharts,
                      tempTabIndexPieChart,
                      multiplePieChart,
                      setMultiplePieChart,
                      tempTabIndexBarChart,
                      multipleBarChart,
                      setMultipleBarChart,
                      tempTabIndexHistogram,
                      multipleHistogram,
                      setMultipleHistogram,
                      tempTabIndexGauge,
                      multipleGauge,
                      setMultipleGauge,
                      tempTabIndexProgress,
                      multipleProgress,
                      setMultipleProgress,
                      tempTabIndexCircularProgress,
                      multipleCircularProgress,
                      setMultipleCircularProgress,
                      tempTabIndexDoughnut,
                      multipleDoughnut,
                      setMultipleDoughnut,
                      tempTabIndexGrid,
                      multipleGrid,
                      setMultipleGrid,
                      tempTabIndexTable,
                      multipleTable,
                      setMultipleTable,
                      tempTabIndexLines,
                      multipleLines,
                      setMultipleLines,
                      tempTabIndexPolygone,
                      multiplePolygone,
                      setMultiplePolygone,
                      tempTabIndexPipe,
                      multiplePipe,
                      setMultiplePipe,
                      tempTabIndexSwitch,
                      multipleSwitch,
                      setMultipleSwitch,
                      tempTabIndexCheckbox,
                      multipleCheckbox,
                      setMultipleCheckbox,
                      tempTabIndexRadio,
                      multipleRadio,
                      setMultipleRadio,
                      tempTabIndexSlider,
                      multipleSlider,
                      setMultipleSlider,
                      tempTabIndexLamp,
                      multipleLamp,
                      setMultipleLamp,
                      tempTabIndexPush,
                      multiplePush,
                      setMultiplePush,
                      tempTabIndexLink,
                      multipleLink,
                      setMultipleLink,
                      tempTabIndexClock,
                      multipleClock,
                      setMultipleClock,
                      setTempTabIndexSquare,
                      setTempTabIndexCircle,
                      setTempTabIndexImages,
                      setTempTabIndexDisplay,
                      setTempTabIndexDevices,
                      setTempTabIndexController,
                      setTempTabIndexFlowM,
                      setTempTabIndexEnergyM,
                      setTempTabIndexMotor,
                      setTempTabIndexText,
                      setTempTabIndexLineChart,
                      setTempTabIndexPieChart,
                      setTempTabIndexBarChart,
                      setTempTabIndexHistogram,
                      setTempTabIndexGauge,
                      setTempTabIndexProgress,
                      setTempTabIndexCircularProgress,
                      setTempTabIndexDoughnut,
                      setTempTabIndexGrid,
                      setTempTabIndexTable,
                      setTempTabIndexLines,
                      setTempTabIndexPolygone,
                      setTempTabIndexPipe,
                      setTempTabIndexSwitch,
                      setTempTabIndexCheckbox,
                      setTempTabIndexRadio,
                      setTempTabIndexSlider,
                      setTempTabIndexLamp,
                      setTempTabIndexPush,
                      setTempTabIndexLink,
                      setTempTabIndexClock

                    })}

                  >
                    Send Back
                  </button>

                  <button
                    onClick={() => WidgetZIndexChange({
                      action: "BringFront",
                      setIsSubMenu,
                      currentDevice,
                      tempTabIndexSquare,
                      tempTabIndexCircle,
                      activeTabIndex,
                      selectedDevice,
                      clickedDeviceIndex,
                      tempImages,
                      setTempImages,
                      setUpdatedImages,
                      multipleSquare,
                      setMultipleSquare,
                      multipleCircle,
                      setMultipleCircle,
                      tempTabIndexImages,
                      multipleImages,
                      setMultipleImages,
                      tempTabIndexDisplay,
                      multipleDisplay,
                      setMultipleDisplay,
                      tempTabIndexDevices,
                      multipleDevices,
                      setMultipleDevices,
                      tempTabIndexController,
                      multipleController,
                      setMultipleController,
                      tempTabIndexFlowM,
                      multipleFlowM,
                      setMultipleFlowM,
                      tempTabIndexEnergyM,
                      multipleEnergyM,
                      setMultipleEnergyM,
                      tempTabIndexMotor,
                      multipleMotor,
                      setMultipleMotor,
                      tempTabIndexText,
                      multipleText,
                      setMultipleText,
                      tempTabIndexLineChart,
                      multipleLineCharts,
                      setMultipleLineCharts,
                      tempTabIndexPieChart,
                      multiplePieChart,
                      setMultiplePieChart,
                      tempTabIndexBarChart,
                      multipleBarChart,
                      setMultipleBarChart,
                      tempTabIndexHistogram,
                      multipleHistogram,
                      setMultipleHistogram,
                      tempTabIndexGauge,
                      multipleGauge,
                      setMultipleGauge,
                      tempTabIndexProgress,
                      multipleProgress,
                      setMultipleProgress,
                      tempTabIndexCircularProgress,
                      multipleCircularProgress,
                      setMultipleCircularProgress,
                      tempTabIndexDoughnut,
                      multipleDoughnut,
                      setMultipleDoughnut,
                      tempTabIndexGrid,
                      multipleGrid,
                      setMultipleGrid,
                      tempTabIndexTable,
                      multipleTable,
                      setMultipleTable,
                      tempTabIndexLines,
                      multipleLines,
                      setMultipleLines,
                      tempTabIndexPolygone,
                      multiplePolygone,
                      setMultiplePolygone,
                      tempTabIndexPipe,
                      multiplePipe,
                      setMultiplePipe,
                      tempTabIndexSwitch,
                      multipleSwitch,
                      setMultipleSwitch,
                      tempTabIndexCheckbox,
                      multipleCheckbox,
                      setMultipleCheckbox,
                      tempTabIndexRadio,
                      multipleRadio,
                      setMultipleRadio,
                      tempTabIndexSlider,
                      multipleSlider,
                      setMultipleSlider,
                      tempTabIndexLamp,
                      multipleLamp,
                      setMultipleLamp,
                      tempTabIndexPush,
                      multiplePush,
                      setMultiplePush,
                      tempTabIndexLink,
                      multipleLink,
                      setMultipleLink,
                      tempTabIndexClock,
                      multipleClock,
                      setMultipleClock,
                      setTempTabIndexSquare,
                      setTempTabIndexCircle,
                      setTempTabIndexImages,
                      setTempTabIndexDisplay,
                      setTempTabIndexDevices,
                      setTempTabIndexController,
                      setTempTabIndexFlowM,
                      setTempTabIndexEnergyM,
                      setTempTabIndexMotor,
                      setTempTabIndexText,
                      setTempTabIndexLineChart,
                      setTempTabIndexPieChart,
                      setTempTabIndexBarChart,
                      setTempTabIndexHistogram,
                      setTempTabIndexGauge,
                      setTempTabIndexProgress,
                      setTempTabIndexCircularProgress,
                      setTempTabIndexDoughnut,
                      setTempTabIndexGrid,
                      setTempTabIndexTable,
                      setTempTabIndexLines,
                      setTempTabIndexPolygone,
                      setTempTabIndexPipe,
                      setTempTabIndexSwitch,
                      setTempTabIndexCheckbox,
                      setTempTabIndexRadio,
                      setTempTabIndexSlider,
                      setTempTabIndexLamp,
                      setTempTabIndexPush,
                      setTempTabIndexLink,
                      setTempTabIndexClock

                    })}
                  >
                    Bring Front
                  </button>
                </div>
              )}


            </div>
          )}

          {isDeviceMenu && (
            <div
              className={styles.deviceMenu}
              style={{
                top: deviceMenuPosition.y,
                left: deviceMenuPosition.x,
                boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
              }}
              onMouseLeave={(e) => handleMouseLeave(e)}
            >

              {
                currentDevice === 'Controller' ||
                  currentDevice === 'Indicator' ||
                  currentDevice === 'EnergyMeter' ||
                  currentDevice === 'FlowMeter' ? (
                  <button
                    className={styles.deviceRenameBtn}
                    onClick={handleRenameDeviceModal}
                  >
                    Rename
                  </button>
                ) : null}
              <button
                className={styles.deviceDeleteBtn}
                onClick={
                  multipleDevices.length > 1 ||
                    multipleController.length > 1 ||
                    multipleIO.length > 1 ||
                    multipleFlowM.length > 1 ||
                    multipleEnergyM.length > 1 ||
                    multipleLineCharts.length > 1 ||
                    multiplePieChart.length > 1 ||
                    multipleBarChart.length > 1 ||
                    multipleHistogram.length > 1 ||
                    multipleGauge.length > 1 ||
                    multipleProgress.length > 1 ||
                    multipleTable.length > 1 ||
                    multipleGrid.length > 1 ||
                    multipleMotor.length > 1 ||
                    multipleDisplay.length > 1 ||
                    multipleText.length > 1 ||
                    multipleCircularProgress.length > 1 ||
                    multipleDoughnut.length > 1 ||
                    multipleLines.length > 1 ||
                    multipleSquare.length > 1 ||
                    multipleCircle.length > 1 ||
                    multiplePolygone.length > 1 ||
                    multipleSwitch.length > 1 ||
                    multipleCheckbox.length > 1 ||
                    multipleRadio.length > 1 ||
                    multipleSlider.length > 1 ||
                    multipleLamp.length > 1 ||
                    multiplePush.length > 1 ||
                    multipleLink.length > 1 ||
                    multipleClock.length > 1 ||
                    multiplePipe.length > 1
                    ? () =>
                      DeleteNewWidgets({
                        setIsDeviceMenu,
                        currentDevice,
                        multipleDevices,
                        clickedDeviceIndex,
                        setMultipleDevices,
                        multipleDisplay,
                        setMultipleDisplay,
                        multipleController,
                        setMultipleController,
                        multipleIO,
                        setMultipleIO,
                        multipleFlowM,
                        setMultipleFlowM,
                        multipleEnergyM,
                        setMultipleEnergyM,
                        multipleMotor,
                        setMultipleMotor,
                        multipleText,
                        setMultipleText,
                        multipleLineCharts,
                        setMultipleLineCharts,
                        multiplePieChart,
                        setMultiplePieChart,
                        multipleBarChart,
                        setMultipleBarChart,
                        multipleHistogram,
                        setMultipleHistogram,
                        multipleGauge,
                        setMultipleGauge,
                        multipleProgress,
                        setMultipleProgress,
                        multipleGrid,
                        setMultipleGrid,
                        multipleTable,
                        setMultipleTable,
                        multipleCircularProgress,
                        setMultipleCircularProgress,
                        setMultipleDoughnut,
                        multipleDoughnut,
                        multipleLines,
                        setMultipleLines,
                        setMultipleCircle,
                        multipleCircle,
                        setMultipleSquare,
                        multipleSquare,
                        multiplePolygone,
                        setMultiplePolygone,
                        multipleSwitch,
                        setMultipleSwitch,
                        multipleCheckbox,
                        setMultipleCheckbox,
                        multipleRadio,
                        setMultipleRadio,
                        multipleSlider,
                        setMultipleSlider,
                        multipleLamp,
                        setMultipleLamp,
                        multiplePush,
                        setMultiplePush,
                        multipleLink,
                        setMultipleLink,
                        multipleClock,
                        setMultipleClock,
                        multiplePipe,
                        setMultiplePipe
                      })
                    : () =>
                      DeleteSavedWidgets({
                        setIsDeviceMenu,
                        currentDevice,
                        tempTabIndexDevices,
                        activeTabIndex,
                        selectedDevice,
                        setTempTabIndexDevices,
                        setUpdatedTabIndexDevices,
                        setTabIndexDevices,
                        indicatorRefs,
                        tempImages,
                        setTempImages,
                        setUpdatedImages,
                        setIndexesToDeleteImg,
                        indexesToDeleteImg,
                        tempTabIndexDisplay,
                        setTempTabIndexDisplay,
                        setUpdatedTabIndexDisplay,
                        setTabIndexDisplay,
                        displayRefs,
                        tempTabIndexController,
                        setTempTabIndexController,
                        setUpdatedTabIndexController,
                        setTabIndexController,
                        controllerRefs,
                        tempTabIndexIO,
                        setTempTabIndexIO,
                        setUpdatedTabIndexIO,
                        setTabIndexIO,
                        ioRefs,
                        tempTabIndexFlowM,
                        setTempTabIndexFlowM,
                        setUpdatedTabIndexFlowM,
                        setTabIndexFlowM,
                        flowMRefs,
                        tempTabIndexEnergyM,
                        setTempTabIndexEnergyM,
                        setUpdatedTabIndexEnergyM,
                        setTabIndexEnergyM,
                        energyMRefs,
                        tempTabIndexMotor,
                        setTempTabIndexMotor,
                        setUpdatedTabIndexMotor,
                        setTabIndexMotor,
                        motorRefs,
                        tempTabIndexText,
                        setTempTabIndexText,
                        setUpdatedTabIndexText,
                        setTabIndexText,
                        textRefs,
                        tempTabIndexLineChart,
                        setTempTabIndexLineChart,
                        setUpdatedTabIndexLineChart,
                        setTabIndexLineChart,
                        lineChartRefs,
                        tempTabIndexPieChart,
                        setTempTabIndexPieChart,
                        setUpdatedTabIndexPieChart,
                        setTabIndexPieChart,
                        pieChartRefs,
                        tempTabIndexBarChart,
                        setTempTabIndexBarChart,
                        setUpdatedTabIndexBarChart,
                        setTabIndexBarChart,
                        barChartRefs,
                        tempTabIndexHistogram,
                        setTempTabIndexHistogram,
                        setUpdatedTabIndexHistogram,
                        setTabIndexHistogram,
                        histogramRefs,
                        tempTabIndexGauge,
                        setTempTabIndexGauge,
                        setUpdatedTabIndexGauge,
                        setTabIndexGauge,
                        gaugeRefs,
                        tempTabIndexProgress,
                        setTempTabIndexProgress,
                        setUpdatedTabIndexProgress,
                        setTabIndexProgress,
                        progressBarRefs,
                        tempTabIndexGrid,
                        setTempTabIndexGrid,
                        setUpdatedTabIndexGrid,
                        setTabIndexGrid,
                        gridRefs,
                        tempTabIndexTable,
                        setTempTabIndexTable,
                        setUpdatedTabIndexTable,
                        setTabIndexTable,
                        tableRefs,
                        updatedTabIndexController,
                        tempTabIndexCircularProgress,
                        setTempTabIndexCircularProgress,
                        setUpdatedTabIndexCircularProgress,
                        setTabIndexCircularProgress,
                        circularProgressRefs,
                        tempTabIndexDoughnut,
                        setTempTabIndexDoughnut,
                        setUpdatedTabIndexDoughnut,
                        setTabIndexDoughnut,
                        doughnutRefs,
                        tempTabIndexLines,
                        setTempTabIndexLines,
                        setUpdatedTabIndexLines,
                        setTabIndexLines,
                        lineRefs,
                        tempTabIndexSquare,
                        setTempTabIndexSquare,
                        setUpdatedTabIndexSquare,
                        setTabIndexSquare,
                        squareRefs,
                        circleRefs,
                        setTabIndexCircle,
                        setUpdatedTabIndexCircle,
                        setTempTabIndexCircle,
                        tempTabIndexCircle,
                        polygoneRefs,
                        setTabIndexPolygone,
                        setUpdatedTabIndexPolygone,
                        tempTabIndexPolygone,
                        setTempTabIndexPolygone,
                        pipeRefs,
                        setTabIndexPipe,
                        setUpdatedTabIndexPipe,
                        setTempTabIndexPipe,
                        tempTabIndexPipe,
                        switchRefs,
                        setTabIndexSwitch,
                        setUpdatedTabIndexSwitch,
                        setTempTabIndexSwitch,
                        tempTabIndexSwitch,
                        checkboxRefs,
                        setTabIndexCheckbox,
                        setUpdatedTabIndexCheckbox,
                        setTempTabIndexCheckbox,
                        tempTabIndexCheckbox,
                        radioRefs,
                        setTabIndexRadio,
                        setUpdatedTabIndexRadio,
                        setTempTabIndexRadio,
                        tempTabIndexRadio,
                        sliderRefs,
                        setTabIndexSlider,
                        setUpdatedTabIndexSlider,
                        setTempTabIndexSlider,
                        tempTabIndexSlider,
                        lampRefs,
                        setTabIndexLamp,
                        setUpdatedTabIndexLamp,
                        setTempTabIndexLamp,
                        tempTabIndexLamp,
                        pushRefs,
                        setTabIndexPush,
                        setUpdatedTabIndexPush,
                        setTempTabIndexPush,
                        tempTabIndexPush,
                        linkRefs,
                        setTabIndexLink,
                        setUpdatedTabIndexLink,
                        setTempTabIndexLink,
                        tempTabIndexLink,
                        clockRefs,
                        setTabIndexClock,
                        setUpdatedTabIndexClock,
                        setTempTabIndexClock,
                        tempTabIndexClock,

                      })
                }
              >
                Delete
              </button>

              {currentDevice === "Radio" && (
                <>
                  <button className={styles.rangeBtn} onClick={handleAddButton}>
                    Add Button
                  </button>
                  <button className={styles.rangeBtn} onClick={handleDeleteButton}>
                    Delete Button
                  </button>
                </>

              )}

              {currentDevice === 'Controller' ||
                currentDevice === 'Indicator' ||
                currentDevice === 'DigitalIO' ||
                currentDevice === 'EnergyMeter' ||
                currentDevice === 'FlowMeter' ||
                currentDevice === 'ProgressBar' ||
                currentDevice === 'CircularProgress' ||
                currentDevice === 'LineChart' ||
                currentDevice === 'PieChart' ||
                currentDevice === 'BarChart' ||
                currentDevice === 'Histogram' ||
                currentDevice === 'Gauge' ||
                currentDevice === 'Grid' ||
                currentDevice === 'Table' ||
                currentDevice === 'Motor' ||
                currentDevice === 'Display' ||
                currentDevice === 'Doughnut' ||
                currentDevice === "Slider" ||
                currentDevice === "Lamp" ||
                currentDevice === "Switch" ||
                currentDevice === "Square" ||
                currentDevice === "Circle" ||
                currentDevice === "Text" ||
                currentDevice === "Pipe"
                ? (
                  <button
                    className={styles.channelsBtn}
                    onClick={handleChannelsBtn}
                  >
                    Channels
                  </button>
                ) : null}

              {tabIndexGauge[activeTabIndex]
                ?.map((chart) =>
                  chart?.deviceType.includes(selectedDevice?.deviceType),
                )
                .includes(true) ||
                currentDevice === 'ProgressBar' ||
                currentDevice === "Gauge" ||
                currentDevice === 'CircularProgress' ||
                currentDevice === "Slider"
                ? (
                  <button
                    className={styles.rangeBtn}
                    onClick={() => setIsRangeModal(true)}
                  >
                    Range
                  </button>
                ) : null}

              {currentDevice === 'ProgressBar' ? (
                <button
                  className={styles.rangeBtn}
                  onClick={() =>
                    handleRotateBar({
                      setRotateBar,
                      rotateBar,
                      tempTabIndexProgress,
                      activeTabIndex,
                      tempImages,
                      selectedDevice,
                      clickedDeviceIndex,
                      setTempImages,
                      setUpdatedImages,
                      setImages,
                      setTempTabIndexProgress,
                      setUpdatedTabIndexProgress,
                    })
                  }
                >
                  Rotate
                </button>
              ) : null}

              {currentDevice === 'LineChart' ||
                currentDevice === 'Histogram' ? (
                <buttton
                  className={styles.timePeriodBtn}
                  onClick={handleTimePeriod}
                >
                  Time Period
                </buttton>
              ) : null}

              {currentDevice === 'Table' ? (
                <button
                  className={styles.rangeBtn}
                  onClick={() =>
                    handleChangeFormat({
                      setTableFormat,
                      tableFormat,
                      tempTabIndexTable,
                      activeTabIndex,
                      tempImages,
                      selectedDevice,
                      clickedDeviceIndex,
                      setTempImages,
                      setUpdatedImages,
                      setTempTabIndexTable,
                      setUpdatedTabIndexTable,
                      multipleTable,
                      setMultipleTable,
                    })
                  }
                >
                  Change Format
                </button>
              ) : null}

              {currentDevice === 'Display' ||
                currentDevice === 'Text' ||
                currentDevice === 'Square' ||
                currentDevice === 'Circle' ||
                currentDevice === "Polygone" ||
                currentDevice === "Link" ||
                currentDevice === "Clock" ||
                currentDevice === "DigitalIO" ||
                currentDevice === "Pipe" ||
                currentDevice === "Gauge" ||
                currentDevice === "ProgressBar" ||
                currentDevice === "Line" ||
                currentDevice === "Switch" ||
                currentDevice === "Slider"
                ?
                (
                  <button
                    className={styles.rangeBtn}
                    onClick={handleProperties}
                  >
                    Properties
                  </button>
                ) : null}


              {(currentDevice === "DigitalIO" || currentDevice === "Square" || currentDevice === "Circle") && (
                <button
                  className={styles.rangeBtn}
                  onClick={() => setIsChangeText(true)}
                >
                  Change Text
                </button>
              )}
              {(currentDevice === "DigitalIO" || currentDevice === "Square" || currentDevice === "Circle") && (
                <button
                  className={styles.rangeBtn}
                  onClick={() => setIsChangeColor(true)}
                >
                  Change Color
                </button>
              )}

              {currentDevice === "DigitalIO" && (
                <button
                  className={styles.rangeBtn}
                  onClick={() => setIsSetLimit(true)}
                >
                  Set Limit
                </button>
              )}

              {(currentDevice === "Square" || currentDevice === "Circle" || currentDevice === "Image" || currentDevice === "Display" || currentDevice === "Text" || currentDevice === "Polygone" || currentDevice === "Link" || currentDevice === "Clock" || currentDevice === "Pipe" || currentDevice === "Switch" || currentDevice === "Checkbox" || currentDevice === "Radio" || currentDevice === "DigitalIO" || currentDevice === "Push" || currentDevice === "Slider" || currentDevice === "Motor" || currentDevice === "Line" || currentDevice === "Lamp") && (
                <button
                  className={styles.rangeBtn}
                  onClick={() => setIsHidePopup(true)}
                >
                  Hide
                </button>
              )}

              {(currentDevice === "Square" || currentDevice === "Circle" || currentDevice === "Image" || currentDevice === "Line"
                // || currentDevice === "Display" || currentDevice === "Text" || currentDevice === "Polygone" || currentDevice === "Link" || currentDevice === "Clock" || currentDevice === "Pipe" || currentDevice === "Switch" || currentDevice === "Checkbox" || currentDevice === "Radio" || currentDevice === "DigitalIO" || currentDevice === "Push" || currentDevice === "Slider" || currentDevice === "Motor"  || currentDevice === "Lamp"
              ) && (
                  <button
                    className={styles.rangeBtn}
                    onClick={(e) => handleHorizontalMoveClick(e)}

                  >
                    Horizontal Movement
                  </button>
                )}

              {(currentDevice === "Square" || currentDevice === "Circle" || currentDevice === "Image" || currentDevice === "Line") && (
                <button
                  className={styles.rangeBtn}
                  onClick={(e) => handleVerticalMoveClick(e)}

                >
                  Vertical Movement
                </button>
              )}

              {currentDevice === "LineChart" && (

                <button
                  className={styles.rangeBtn}
                  onClick={handleOpenLineStyle}
                >
                  Line Style
                </button>
              )}

              {currentDevice === "LineChart" && (

                <button
                  className={styles.rangeBtn}
                  onClick={handleOpenYAxisRange}
                >
                  Y Axis Range
                </button>

              )}

              {currentDevice === "LineChart" && (

                <button
                  className={styles.rangeBtn}
                  onClick={handleOpenGraphInterval}
                >
                  Interval
                </button>

              )}


              {currentDevice === "Square" && (
                <button
                  className={styles.rangeBtn}
                  onClick={handleOpenBlinkModal}
                >
                  Blink
                </button>
              )}



              <button className={styles.rangeBtn} onMouseEnter={(e) => handleMouseEnter(e)}>
                Position &gt;
              </button>

              {isSubMenu && (
                <div className={styles.subMenu} style={{ top: subMenuPosi.y, left: subMenuPosi.x + 10 }}>
                  <button
                    onClick={() => WidgetZIndexChange({
                      action: "SendBack",
                      setIsSubMenu,
                      currentDevice,
                      tempTabIndexSquare,
                      tempTabIndexCircle,
                      activeTabIndex,
                      selectedDevice,
                      clickedDeviceIndex,
                      tempImages,
                      setTempImages,
                      setUpdatedImages,
                      multipleSquare,
                      setMultipleSquare,
                      multipleCircle,
                      setMultipleCircle,
                      tempTabIndexImages,
                      multipleImages,
                      setMultipleImages,
                      tempTabIndexDisplay,
                      multipleDisplay,
                      setMultipleDisplay,
                      tempTabIndexDevices,
                      multipleDevices,
                      setMultipleDevices,
                      tempTabIndexController,
                      multipleController,
                      setMultipleController,
                      tempTabIndexFlowM,
                      multipleFlowM,
                      setMultipleFlowM,
                      tempTabIndexEnergyM,
                      multipleEnergyM,
                      setMultipleEnergyM,
                      tempTabIndexMotor,
                      multipleMotor,
                      setMultipleMotor,
                      tempTabIndexText,
                      multipleText,
                      setMultipleText,
                      tempTabIndexLineChart,
                      multipleLineCharts,
                      setMultipleLineCharts,
                      tempTabIndexPieChart,
                      multiplePieChart,
                      setMultiplePieChart,
                      tempTabIndexBarChart,
                      multipleBarChart,
                      setMultipleBarChart,
                      tempTabIndexHistogram,
                      multipleHistogram,
                      setMultipleHistogram,
                      tempTabIndexGauge,
                      multipleGauge,
                      setMultipleGauge,
                      tempTabIndexProgress,
                      multipleProgress,
                      setMultipleProgress,
                      tempTabIndexCircularProgress,
                      multipleCircularProgress,
                      setMultipleCircularProgress,
                      tempTabIndexDoughnut,
                      multipleDoughnut,
                      setMultipleDoughnut,
                      tempTabIndexGrid,
                      multipleGrid,
                      setMultipleGrid,
                      tempTabIndexTable,
                      multipleTable,
                      setMultipleTable,
                      tempTabIndexLines,
                      multipleLines,
                      setMultipleLines,
                      tempTabIndexPolygone,
                      multiplePolygone,
                      setMultiplePolygone,
                      tempTabIndexPipe,
                      multiplePipe,
                      setMultiplePipe,
                      tempTabIndexSwitch,
                      multipleSwitch,
                      setMultipleSwitch,
                      tempTabIndexCheckbox,
                      multipleCheckbox,
                      setMultipleCheckbox,
                      tempTabIndexRadio,
                      multipleRadio,
                      setMultipleRadio,
                      tempTabIndexSlider,
                      multipleSlider,
                      setMultipleSlider,
                      tempTabIndexLamp,
                      multipleLamp,
                      setMultipleLamp,
                      tempTabIndexPush,
                      multiplePush,
                      setMultiplePush,
                      tempTabIndexLink,
                      multipleLink,
                      setMultipleLink,
                      tempTabIndexClock,
                      multipleClock,
                      setMultipleClock,
                      setTempTabIndexSquare,
                      setTempTabIndexCircle,
                      setTempTabIndexImages,
                      setTempTabIndexDisplay,
                      setTempTabIndexDevices,
                      setTempTabIndexController,
                      setTempTabIndexFlowM,
                      setTempTabIndexEnergyM,
                      setTempTabIndexMotor,
                      setTempTabIndexText,
                      setTempTabIndexLineChart,
                      setTempTabIndexPieChart,
                      setTempTabIndexBarChart,
                      setTempTabIndexHistogram,
                      setTempTabIndexGauge,
                      setTempTabIndexProgress,
                      setTempTabIndexCircularProgress,
                      setTempTabIndexDoughnut,
                      setTempTabIndexGrid,
                      setTempTabIndexTable,
                      setTempTabIndexLines,
                      setTempTabIndexPolygone,
                      setTempTabIndexPipe,
                      setTempTabIndexSwitch,
                      setTempTabIndexCheckbox,
                      setTempTabIndexRadio,
                      setTempTabIndexSlider,
                      setTempTabIndexLamp,
                      setTempTabIndexPush,
                      setTempTabIndexLink,
                      setTempTabIndexClock

                    })}

                  >
                    Send Back
                  </button>

                  <button
                    onClick={() => WidgetZIndexChange({
                      action: "BringFront",
                      setIsSubMenu,
                      currentDevice,
                      tempTabIndexSquare,
                      tempTabIndexCircle,
                      activeTabIndex,
                      selectedDevice,
                      clickedDeviceIndex,
                      tempImages,
                      setTempImages,
                      setUpdatedImages,
                      multipleSquare,
                      setMultipleSquare,
                      multipleCircle,
                      setMultipleCircle,
                      tempTabIndexImages,
                      multipleImages,
                      setMultipleImages,
                      tempTabIndexDisplay,
                      multipleDisplay,
                      setMultipleDisplay,
                      tempTabIndexDevices,
                      multipleDevices,
                      setMultipleDevices,
                      tempTabIndexController,
                      multipleController,
                      setMultipleController,
                      tempTabIndexFlowM,
                      multipleFlowM,
                      setMultipleFlowM,
                      tempTabIndexEnergyM,
                      multipleEnergyM,
                      setMultipleEnergyM,
                      tempTabIndexMotor,
                      multipleMotor,
                      setMultipleMotor,
                      tempTabIndexText,
                      multipleText,
                      setMultipleText,
                      tempTabIndexLineChart,
                      multipleLineCharts,
                      setMultipleLineCharts,
                      tempTabIndexPieChart,
                      multiplePieChart,
                      setMultiplePieChart,
                      tempTabIndexBarChart,
                      multipleBarChart,
                      setMultipleBarChart,
                      tempTabIndexHistogram,
                      multipleHistogram,
                      setMultipleHistogram,
                      tempTabIndexGauge,
                      multipleGauge,
                      setMultipleGauge,
                      tempTabIndexProgress,
                      multipleProgress,
                      setMultipleProgress,
                      tempTabIndexCircularProgress,
                      multipleCircularProgress,
                      setMultipleCircularProgress,
                      tempTabIndexDoughnut,
                      multipleDoughnut,
                      setMultipleDoughnut,
                      tempTabIndexGrid,
                      multipleGrid,
                      setMultipleGrid,
                      tempTabIndexTable,
                      multipleTable,
                      setMultipleTable,
                      tempTabIndexLines,
                      multipleLines,
                      setMultipleLines,
                      tempTabIndexPolygone,
                      multiplePolygone,
                      setMultiplePolygone,
                      tempTabIndexPipe,
                      multiplePipe,
                      setMultiplePipe,
                      tempTabIndexSwitch,
                      multipleSwitch,
                      setMultipleSwitch,
                      tempTabIndexCheckbox,
                      multipleCheckbox,
                      setMultipleCheckbox,
                      tempTabIndexRadio,
                      multipleRadio,
                      setMultipleRadio,
                      tempTabIndexSlider,
                      multipleSlider,
                      setMultipleSlider,
                      tempTabIndexLamp,
                      multipleLamp,
                      setMultipleLamp,
                      tempTabIndexPush,
                      multiplePush,
                      setMultiplePush,
                      tempTabIndexLink,
                      multipleLink,
                      setMultipleLink,
                      tempTabIndexClock,
                      multipleClock,
                      setMultipleClock,
                      setTempTabIndexSquare,
                      setTempTabIndexCircle,
                      setTempTabIndexImages,
                      setTempTabIndexDisplay,
                      setTempTabIndexDevices,
                      setTempTabIndexController,
                      setTempTabIndexFlowM,
                      setTempTabIndexEnergyM,
                      setTempTabIndexMotor,
                      setTempTabIndexText,
                      setTempTabIndexLineChart,
                      setTempTabIndexPieChart,
                      setTempTabIndexBarChart,
                      setTempTabIndexHistogram,
                      setTempTabIndexGauge,
                      setTempTabIndexProgress,
                      setTempTabIndexCircularProgress,
                      setTempTabIndexDoughnut,
                      setTempTabIndexGrid,
                      setTempTabIndexTable,
                      setTempTabIndexLines,
                      setTempTabIndexPolygone,
                      setTempTabIndexPipe,
                      setTempTabIndexSwitch,
                      setTempTabIndexCheckbox,
                      setTempTabIndexRadio,
                      setTempTabIndexSlider,
                      setTempTabIndexLamp,
                      setTempTabIndexPush,
                      setTempTabIndexLink,
                      setTempTabIndexClock

                    })}
                  >
                    Bring Front
                  </button>
                </div>
              )}
            </div>

          )}

          <RangeModal
            isRangeModel={isRangeModel}
            setIsRangeModal={setIsRangeModal}
            currentDevice={currentDevice}
            handleRangeSave={handleRangeSave}
            setChangeRange={setChangeRange}
            changeRange={changeRange}
            setStartPoint={setStartPoint}
            startPoint={startPoint}
            setEndPoint={setEndPoint}
            endPoint={endPoint}
            setSpecificMaxVal={setSpecificMaxVal}
            setSpecificMinVal={setSpecificMinVal}
            tempImages={tempImages}
            selectedDevice={selectedDevice}
            tempTabIndexGauge={tempTabIndexGauge}
            activeTabIndex={activeTabIndex}
            clickedDeviceIndex={clickedDeviceIndex}
            setTempImages={setTempImages}
            setUpdatedImages={setUpdatedImages}
            setTempTabIndexGauge={setTempTabIndexGauge}
            setUpdatedTabIndexGauge={setUpdatedTabIndexGauge}
            multipleGauge={multipleGauge}
            setMultipleGauge={setMultipleGauge}
            setUpdatedMultipleGauge={setUpdatedMultipleGauge}
            setMaximumVal={setMaximumVal}
            maximumVal={maximumVal}
            setMinimumVal={setMinimumVal}
            minimumVal={minimumVal}
            multipleProgress={multipleProgress}
            tabIndexProgress={tabIndexProgress}
            tempTabIndexProgress={tempTabIndexProgress}
            setImages={setImages}
            setMultipleProgress={setMultipleProgress}
            setUpdatedMultipleProgress={setUpdatedMultipleProgress}
            setTempTabIndexProgress={setTempTabIndexProgress}
            setUpdatedTabIndexProgress={setUpdatedTabIndexProgress}
            multipleCircularProgress={multipleCircularProgress}
            tabIndexCircularProgress={tabIndexCircularProgress}
            tempTabIndexCircularProgress={tempTabIndexCircularProgress}
            setTempTabIndexCircularProgress={setTempTabIndexCircularProgress}
            setUpdatedTabIndexCircularProgress={setUpdatedTabIndexCircularProgress}
            setMultipleCircularProgress={setMultipleCircularProgress}
            setUpdatedMultipleCircularProgress={setUpdatedMultipleCircularProgress}
            updatedMultipleCircularProgress={updatedMultipleCircularProgress}
            updatedMultipleProgress={updatedMultipleProgress}
            updatedMultipleGauge={updatedMultipleGauge}
            multipleSlider={multipleSlider}
            tabIndexSlider={tabIndexSlider}
            tempTabIndexSlider={tempTabIndexSlider}
            setTempTabIndexSlider={setTempTabIndexSlider}
            setUpdatedTabIndexSlider={setUpdatedTabIndexSlider}
            updatedMultipleSlider={updatedMultipleSlider}
            setMultipleSlider={setMultipleSlider}
            setUpdatedMultipleSlider={setUpdatedMultipleSlider}
          />


          <ChannelsModal
            isChannels={isChannels}
            setIsChannels={setIsChannels}
            currentDevice={currentDevice}
            tableData={tableData}
            apiChannels={apiChannels}
            widgetData={widgetData}
            plusIcon={plusIcon}
            displaySelectTag={displaySelectTag}
            handleSelectChange={handleSelectChange}
            handlePlusIcon={handlePlusIcon}
            WidgetSelectChannel={WidgetSelectChannel}
            lampStatus={lampStatus}
            setLampStatus={setLampStatus}
            setCurrentPVChannel={setCurrentPVChannel}
            tempImages={tempImages}
            selectedDevice={selectedDevice}
            setPVSpecificChannel={setPVSpecificChannel}
            pvSpecificChannel={pvSpecificChannel}
            tempTabIndexDevices={tempTabIndexDevices}
            activeTabIndex={activeTabIndex}
            clickedDeviceIndex={clickedDeviceIndex}
            setTempImages={setTempImages}
            setUpdatedImages={setUpdatedImages}
            setTempTabIndexDevices={setTempTabIndexDevices}
            setUpdatedTabIndexDevices={setUpdatedTabIndexDevices}
            multipleDevices={multipleDevices}
            setMultipleDevices={setMultipleDevices}
            tempTabIndexDisplay={tempTabIndexDisplay}
            setTempTabIndexDisplay={setTempTabIndexDisplay}
            setUpdatedTabIndexDisplay={setUpdatedTabIndexDisplay}
            multipleDisplay={multipleDisplay}
            setMultipleDisplay={setMultipleDisplay}
            setCurrentPVController={setCurrentPVController}
            setCurrentSVController={setCurrentSVController}
            setPVControllerChannel={setPVControllerChannel}
            pvControllerChannel={pvControllerChannel}
            setSVControllerChannel={setSVControllerChannel}
            svControllerChannel={svControllerChannel}
            tempTabIndexController={tempTabIndexController}
            setTempTabIndexController={setTempTabIndexController}
            setUpdatedTabIndexController={setUpdatedTabIndexController}
            multipleController={multipleController}
            setMultipleController={setMultipleController}
            tempTabIndexIO={tempTabIndexIO}
            setTempTabIndexIO={setTempTabIndexIO}
            setUpdatedTabIndexIO={setUpdatedTabIndexIO}
            multipleIO={multipleIO}
            setMultipleIO={setMultipleIO}
            setCurrentPVFlowM={setCurrentPVFlowM}
            setCurrentSVFlowM={setCurrentSVFlowM}
            setPVFlowMChannels={setPVFlowMChannels}
            pvFlowMChannels={pvFlowMChannels}
            setSVFlowMChannels={setSVFlowMChannels}
            svFlowMChannels={svFlowMChannels}
            tempTabIndexFlowM={tempTabIndexFlowM}
            setTempTabIndexFlowM={setTempTabIndexFlowM}
            setUpdatedTabIndexFlowM={setUpdatedTabIndexFlowM}
            multipleFlowM={multipleFlowM}
            setMultipleFlowM={setMultipleFlowM}
            setCurrentPVEnergyM={setCurrentPVEnergyM}
            setCurrentSVEnergyM={setCurrentSVEnergyM}
            setPVEnergyMChannels={setPVEnergyMChannels}
            pvEnergyMChannels={pvEnergyMChannels}
            setSVEnergyMChannels={setSVEnergyMChannels}
            svEnergyMChannels={svEnergyMChannels}
            tempTabIndexEnergyM={tempTabIndexEnergyM}
            setTempTabIndexEnergyM={setTempTabIndexEnergyM}
            setUpdatedTabIndexEnergyM={setUpdatedTabIndexEnergyM}
            multipleEnergyM={multipleEnergyM}
            setMultipleEnergyM={setMultipleEnergyM}
            tempTabIndexMotor={tempTabIndexMotor}
            setTempTabIndexMotor={setTempTabIndexMotor}
            setUpdatedTabIndexMotor={setUpdatedTabIndexMotor}
            multipleMotor={multipleMotor}
            setMultipleMotor={setMultipleMotor}
            tempTabIndexLineChart={tempTabIndexLineChart}
            lineChartChannels={lineChartChannels}
            setTempTabIndexLineChart={setTempTabIndexLineChart}
            setUpdatedTabIndexLineChart={setUpdatedTabIndexLineChart}
            multipleLineCharts={multipleLineCharts}
            setMultipleLineCharts={setMultipleLineCharts}
            setLineChartChannels={setLineChartChannels}
            tempTabIndexPieChart={tempTabIndexPieChart}
            pieChartChannels={pieChartChannels}
            setTempTabIndexPieChart={setTempTabIndexPieChart}
            setUpdatedTabIndexPieChart={setUpdatedTabIndexPieChart}
            multiplePieChart={multiplePieChart}
            setMultiplePieChart={setMultiplePieChart}
            setPieChartChannels={setPieChartChannels}
            tempTabIndexBarChart={tempTabIndexBarChart}
            barChartChannels={barChartChannels}
            setTempTabIndexBarChart={setTempTabIndexBarChart}
            setUpdatedTabIndexBarChart={setUpdatedTabIndexBarChart}
            multipleBarChart={multipleBarChart}
            setMultipleBarChart={setMultipleBarChart}
            setBarChartChannels={setBarChartChannels}
            tempTabIndexHistogram={tempTabIndexHistogram}
            histogramChannels={histogramChannels}
            setTempTabIndexHistogram={setTempTabIndexHistogram}
            setUpdatedTabIndexHistogram={setUpdatedTabIndexHistogram}
            multipleHistogram={multipleHistogram}
            setMultipleHistogram={setMultipleHistogram}
            setHistogramChannels={setHistogramChannels}
            setGaugeChannels={setGaugeChannels}
            tempTabIndexGauge={tempTabIndexGauge}
            gaugeChannels={gaugeChannels}
            setTempTabIndexGauge={setTempTabIndexGauge}
            setUpdatedTabIndexGauge={setUpdatedTabIndexGauge}
            multipleGauge={multipleGauge}
            setMultipleGauge={setMultipleGauge}
            setProgressChannels={setProgressChannels}
            progressChannels={progressChannels}
            tempTabIndexProgress={tempTabIndexProgress}
            setTempTabIndexProgress={setTempTabIndexProgress}
            setUpdatedTabIndexProgress={setUpdatedTabIndexProgress}
            multipleProgress={multipleProgress}
            setMultipleProgress={setMultipleProgress}
            tempTabIndexTable={tempTabIndexTable}
            tableChannels={tableChannels}
            setTempTabIndexTable={setTempTabIndexTable}
            setUpdatedTabIndexTable={setUpdatedTabIndexTable}
            multipleTable={multipleTable}
            setMultipleTable={setMultipleTable}
            setTableChannels={setTableChannels}
            tempTabIndexCircularProgress={tempTabIndexCircularProgress}
            setTempTabIndexCircularProgress={setTempTabIndexCircularProgress}
            setUpdatedTabIndexCircularProgress={setUpdatedTabIndexCircularProgress}
            multipleCircularProgress={multipleCircularProgress}
            setMultipleCircularProgress={setMultipleCircularProgress}
            tempTabIndexDoughnut={tempTabIndexDoughnut}
            doughnutChannels={doughnutChannels}
            setTempTabIndexDoughnut={setTempTabIndexDoughnut}
            setUpdatedTabIndexDoughnut={setUpdatedTabIndexDoughnut}
            multipleDoughnut={multipleDoughnut}
            setMultipleDoughnut={setMultipleDoughnut}
            setDoughnutChannels={setDoughnutChannels}
            sliderChannels={sliderChannels}
            tempTabIndexSlider={tempTabIndexSlider}
            setTempTabIndexSlider={setTempTabIndexSlider}
            setUpdatedTabIndexSlider={setUpdatedTabIndexSlider}
            multipleSlider={multipleSlider}
            setMultipleSlider={setMultipleSlider}
            setSliderChannels={setSliderChannels}
            tempTabIndexLamp={tempTabIndexLamp}
            setTempTabIndexLamp={setTempTabIndexLamp}
            setUpdatedTabIndexLamp={setUpdatedTabIndexLamp}
            multipleLamp={multipleLamp}
            setMultipleLamp={setMultipleLamp}
            tempTabIndexSwitch={tempTabIndexSwitch}
            setTempTabIndexSwitch={setTempTabIndexSwitch}
            setUpdatedTabIndexSwitch={setUpdatedTabIndexSwitch}
            multipleSwitch={multipleSwitch}
            setMultipleSwitch={setMultipleSwitch}
            tempTabIndexSquare={tempTabIndexSquare}
            setTempTabIndexSquare={setTempTabIndexSquare}
            setUpdatedTabIndexSquare={setUpdatedTabIndexSquare}
            multipleSquare={multipleSquare}
            setMultipleSquare={setMultipleSquare}
            tempTabIndexCircle={tempTabIndexCircle}
            setTempTabIndexCircle={setTempTabIndexCircle}
            setUpdatedTabIndexCircle={setUpdatedTabIndexCircle}
            multipleCircle={multipleCircle}
            setMultipleCircle={setMultipleCircle}
            tempTabIndexText={tempTabIndexText}
            setTempTabIndexText={setTempTabIndexText}
            setUpdatedTabIndexText={setUpdatedTabIndexText}
            multipleText={multipleText}
            setMultipleText={setMultipleText}
            tempTabIndexPipe={tempTabIndexPipe}
            setTempTabIndexPipe={setTempTabIndexPipe}
            setUpdatedTabIndexPipe={setUpdatedTabIndexPipe}
            multiplePipe={multiplePipe}
            setMultiplePipe={setMultiplePipe}

          />


          {isChannelCheckBox && (
            <ChannelCheckboxModal
              setIsChannelCheckBox={setIsChannelCheckBox}
              handleAllSelect={handleAllSelect}
              selectAllCheck={selectAllCheck}
              tableData={tableData}
              handleCheckBox={handleCheckBox}
              handleSaveCheckBox={handleSaveCheckBox}
              currentDevice={currentDevice}
              tempTabIndexGrid={tempTabIndexGrid}
              activeTabIndex={activeTabIndex}
              tempImages={tempImages}
              selectedDevice={selectedDevice}
              clickedDeviceIndex={clickedDeviceIndex}
              gridChannels={gridChannels}
              setTempImages={setTempImages}
              setUpdatedImages={setUpdatedImages}
              setTempTabIndexGrid={setTempTabIndexGrid}
              setUpdatedTabIndexGrid={setUpdatedTabIndexGrid}
              multipleGrid={multipleGrid}
              setMultipleGrid={setMultipleGrid}
              setGridChannels={setGridChannels}
            />
          )}

          {/* Opening Context Menu */}
          {openContextMenu && (
            <ContextMenu
              x={contextMenuPosition.x}
              y={contextMenuPosition.y}
              setIsRenameModel={setIsRenameModel}
              handleRenameTab={handleRenameTab}
              handleDeleteTab={handleDeleteTab}
              clickedTabIndex={clickedTabIndex}
            />
          )}
        </div>



        {(isRenameModel || addNewTag || renameDeviceModal) && (
          <RenameModal
            isRenameModel={isRenameModel}
            addNewTag={addNewTag}
            renameDeviceModal={renameDeviceModal}
            setIsRenameModel={setIsRenameModel}
            setAddNewTag={setAddNewTag}
            setRenameDeviceModal={setRenameDeviceModal}
            tabNameInput={tabNameInput}
            setTabNameInput={setTabNameInput}
            handleSaveRenameTab={handleSaveRenameTab}
            handleSaveTab={handleSaveTab}
            WidgetRename={WidgetRename}
            currentDevice={currentDevice}
            tempTabIndexDevices={tempTabIndexDevices}
            activeTabIndex={activeTabIndex}
            selectedDevice={selectedDevice}
            clickedDeviceIndex={clickedDeviceIndex}
            tempImages={tempImages}
            setTempImages={setTempImages}
            setUpdatedImages={setUpdatedImages}
            multipleDevices={multipleDevices}
            setMultipleDevices={setMultipleDevices}
            setDevicesName={setDevicesName}
            devicesName={devicesName}
            setIndexesDeviceName={setIndexesDeviceName}
            indexesDeviceName={indexesDeviceName}
            tempTabIndexController={tempTabIndexController}
            multipleController={multipleController}
            setMultipleController={setMultipleController}
            tempTabIndexIO={tempTabIndexIO}
            multipleIO={multipleIO}
            setMultipleIO={setMultipleIO}
            tempTabIndexFlowM={tempTabIndexFlowM}
            multipleFlowM={multipleFlowM}
            setMultipleFlowM={setMultipleFlowM}
            tempTabIndexEnergyM={tempTabIndexEnergyM}
            multipleEnergyM={multipleEnergyM}
            setMultipleEnergyM={setMultipleEnergyM}
            selectedTab={selectedTab}
          />
        )}


        {isTimePeriod && (
          <TimePeriodModal
            handleCloseTimePeriod={handleCloseTimePeriod}
            handleEndTimeSelect={handleEndTimeSelect}
            endSelect={endSelect}
            endHours={endHours}
            endMinutes={endMinutes}
            handleEndChange={handleEndChange}
            handleEndIncrease={handleEndIncrease}
            handleEndDecrease={handleEndDecrease}
            handleSaveTimePeriod={handleSaveTimePeriod}
            setIsTimePeriod={setIsTimePeriod}
            currentDevice={currentDevice}
            multipleLineCharts={multipleLineCharts}
            tempTabIndexLineChart={tempTabIndexLineChart}
            activeTabIndex={activeTabIndex}
            selectedDevice={selectedDevice}
            clickedDeviceIndex={clickedDeviceIndex}
            tempImages={tempImages}
            setTempImages={setTempImages}
            setUpdatedImages={setUpdatedImages}
            setTempTabIndexLineChart={setTempTabIndexLineChart}
            setUpdatedTabIndexLineChart={setUpdatedTabIndexLineChart}
            setMultipleLineCharts={setMultipleLineCharts}
            multipleHistogram={multipleHistogram}
            tempTabIndexHistogram={tempTabIndexHistogram}
            setTempTabIndexHistogram={setTempTabIndexHistogram}
            setUpdatedTabIndexHistogram={setUpdatedTabIndexHistogram}
            setMultipleHistogram={setMultipleHistogram}
          />
        )}


        {isChangeSV && (
          <ChangeSVModal
            setIsChangeSV={setIsChangeSV}
            handleChangeSV={handleChangeSV}
            currentDevice={currentDevice}
            loginSid={loginSid}
            comid={comid}
            compvtkey={compvtkey}
            key={key}
            dispatch={dispatch}
            deviceGroupName={deviceGroupName}
            deviceName={deviceName}
            toast={toast}
            tagGroupName={tagGroupName}
          />
        )}


        <PropertiesModal
          isBgColor={isBgColor}
          handleChangeBg={handleChangeBg}
          handleIncreaseFontSize={handleIncreaseFontSize}
          handleDecreaseFontSize={handleDecreaseFontSize}
          handleFontSizeInputChange={handleFontSizeInputChange}
          setAddedText={setAddedText}
          setBgColor={setBgColor}
          setTextBgColor={setTextBgColor}
          setTextColor={setTextColor}
          setTextAlignHorizontally={setTextAlignHorizontally}
          setTextAlignVertically={setTextAlignVertically}
          data={{
            currentDevice,
            tempTabIndexDisplay,
            activeTabIndex,
            tempImages,
            selectedDevice,
            clickedDeviceIndex,
            bgColor,
            textColor,
            fontSize,
            setTempImages,
            setUpdatedImages,
            setTempTabIndexDisplay,
            setUpdatedTabIndexDisplay,
            multipleDisplay,
            setMultipleDisplay,
            tempTabIndexText,
            textBgColor,
            widgetTextColor,
            textFontSize,
            addedText,
            textAlignVertically,
            textAlignHorizontally,
            setTempTabIndexText,
            setUpdatedTabIndexText,
            multipleText,
            setMultipleText,
            setIsBgColor,
            tempTabIndexSquare,
            setTempTabIndexSquare,
            setUpdatedTabIndexSquare,
            multipleSquare,
            setMultipleSquare,
            tempTabIndexCircle,
            setTempTabIndexCircle,
            setUpdatedTabIndexCircle,
            multipleCircle,
            setMultipleCircle,
            tempTabIndexPolygone,
            setTempTabIndexPolygone,
            setUpdatedTabIndexPolygone,
            multiplePolygone,
            setMultiplePolygone,
            setMultipleLink,
            multipleLink,
            setUpdatedTabIndexLink,
            setTempTabIndexLink,
            tempTabIndexLink,
            setMultipleClock,
            multipleClock,
            setTempTabIndexClock,
            setUpdatedTabIndexClock,
            tempTabIndexClock,
            setMultipleIO,
            multipleIO,
            setTempTabIndexIO,
            setUpdatedTabIndexIO,
            tempTabIndexIO,
            setMultiplePipe,
            multiplePipe,
            setTempTabIndexPipe,
            setUpdatedTabIndexPipe,
            tempTabIndexPipe,
            setWidgetTextColor,
            multipleGauge,
            setMultipleGauge,
            tempTabIndexGauge,
            setTempTabIndexGauge,
            setUpdatedTabIndexGauge,
            multipleProgress,
            setMultipleProgress,
            tempTabIndexProgress,
            setTempTabIndexProgress,
            setUpdatedTabIndexProgress,
            multipleLines,
            setMultipleLines,
            tempTabIndexLines,
            setTempTabIndexLines,
            setUpdatedTabIndexLines,
            multipleSwitch,
            setMultipleSwitch,
            tempTabIndexSwitch,
            setTempTabIndexSwitch,
            setUpdatedTabIndexSwitch,

            multipleSlider,
            setMultipleSlider,
            tempTabIndexSlider,
            setTempTabIndexSlider,
            setUpdatedTabIndexSlider,

            borderRadius,
            setBorderRadius,
            setIsTransperant,
            isTransparent
          }}
        />


        <ChangeIOText
          isChangeText={isChangeText}
          setIsChangeText={setIsChangeText}
          currentDevice={currentDevice}
          tempTabIndexIO={tempTabIndexIO}
          activeTabIndex={activeTabIndex}
          tempImages={tempImages}
          selectedDevice={selectedDevice}
          clickedDeviceIndex={clickedDeviceIndex}
          setTempImages={setTempImages}
          setUpdatedImages={setUpdatedImages}
          setTempTabIndexIO={setTempTabIndexIO}
          setUpdatedTabIndexIO={setUpdatedTabIndexIO}
          multipleIO={multipleIO}
          setMultipleIO={setMultipleIO}
          onText={onText}
          setOnText={setOnText}
          offText={offText}
          setOffText={setOffText}
          handleIOText={handleIOText}
          setUpdatedTabIndexSquare={setUpdatedTabIndexSquare}
          setTempTabIndexSquare={setTempTabIndexSquare}
          multipleSquare={multipleSquare}
          setMultipleSquare={setMultipleSquare}
          tempTabIndexSquare={tempTabIndexSquare}
          setUpdatedTabIndexCircle={setUpdatedTabIndexCircle}
          setTempTabIndexCircle={setTempTabIndexCircle}
          multipleCircle={multipleCircle}
          setMultipleCircle={setMultipleCircle}
          tempTabIndexCircle={tempTabIndexCircle}

        />


        <ChangeIOColor
          isChangeColor={isChangeColor}
          setIsChangeColor={setIsChangeColor}
          currentDevice={currentDevice}
          tempTabIndexIO={tempTabIndexIO}
          activeTabIndex={activeTabIndex}
          tempImages={tempImages}
          selectedDevice={selectedDevice}
          clickedDeviceIndex={clickedDeviceIndex}
          setTempImages={setTempImages}
          setUpdatedImages={setUpdatedImages}
          setTempTabIndexIO={setTempTabIndexIO}
          setUpdatedTabIndexIO={setUpdatedTabIndexIO}
          multipleIO={multipleIO}
          setMultipleIO={setMultipleIO}
          onColor={onColor}
          setOnColor={setOnColor}
          offColor={offColor}
          setOffColor={setOffColor}
          handleIOColor={handleIOColor}
          setUpdatedTabIndexSquare={setUpdatedTabIndexSquare}
          setTempTabIndexSquare={setTempTabIndexSquare}
          multipleSquare={multipleSquare}
          setMultipleSquare={setMultipleSquare}
          tempTabIndexSquare={tempTabIndexSquare}
          setUpdatedTabIndexCircle={setUpdatedTabIndexCircle}
          setTempTabIndexCircle={setTempTabIndexCircle}
          multipleCircle={multipleCircle}
          setMultipleCircle={setMultipleCircle}
          tempTabIndexCircle={tempTabIndexCircle}
        />

        <SetLimit
          isSetLimit={isSetLimit}
          setIsSetLimit={setIsSetLimit}
          setUpperLimit={setUpperLimit}
          setLowerLimit={setLowerLimit}
        />



        <HidePopup
          isHidePopup={isHidePopup}
          tableData={tableData}
          setIsHidePopup={setIsHidePopup}
          setHideChannel={setHideChannel}
          setHideValue={setHideValue}
          currentDevice={currentDevice}
          activeTabIndex={activeTabIndex}
          tempImages={tempImages}
          selectedDevice={selectedDevice}
          clickedDeviceIndex={clickedDeviceIndex}
          setTempImages={setTempImages}
          setUpdatedImages={setUpdatedImages}
          tempTabIndexSquare={tempTabIndexSquare}
          setTempTabIndexSquare={setTempTabIndexSquare}
          setUpdatedTabIndexSquare={setUpdatedTabIndexSquare}
          multipleSquare={multipleSquare}
          setMultipleSquare={setMultipleSquare}
          hideChannel={hideChannel}
          hideValue={hideValue}
          tempTabIndexCircle={tempTabIndexCircle}
          setTempTabIndexCircle={setTempTabIndexCircle}
          setUpdatedTabIndexCircle={setUpdatedTabIndexCircle}
          multipleCircle={multipleCircle}
          setMultipleCircle={setMultipleCircle}
          tempTabIndexLines={tempTabIndexLines}
          setTempTabIndexLines={setTempTabIndexLines}
          setUpdatedTabIndexLines={setUpdatedTabIndexLines}
          multipleLines={multipleLines}
          setMultipleLines={setMultipleLines}
          tempTabIndexImages={tempTabIndexImages}
          setTempTabIndexImages={setTempTabIndexImages}
          setUpdatedTabIndexImages={setUpdatedTabIndexImages}
          multipleImages={multipleImages}
          setMultipleImages={setMultipleImages}
          setMultipleDisplay={setMultipleDisplay}
          multipleDisplay={multipleDisplay}
          setUpdatedTabIndexDisplay={setUpdatedTabIndexDisplay}

          setTempTabIndexDisplay={setTempTabIndexDisplay}
          tempTabIndexDisplay={tempTabIndexDisplay}

          setMultipleIO={setMultipleIO}
          multipleIO={multipleIO}
          setUpdatedTabIndexIO={setUpdatedTabIndexIO}
          setTempTabIndexIO={setTempTabIndexIO}
          tempTabIndexIO={tempTabIndexIO}

          setMultipleMotor={setMultipleMotor}
          multipleMotor={multipleMotor}
          setUpdatedTabIndexMotor={setUpdatedTabIndexMotor}
          setTempTabIndexMotor={setTempTabIndexMotor}
          tempTabIndexMotor={tempTabIndexMotor}

          setMultiplePolygone={setMultiplePolygone}
          multiplePolygone={multiplePolygone}
          setUpdatedTabIndexPolygone={setUpdatedTabIndexPolygone}
          setTempTabIndexPolygone={setTempTabIndexPolygone}
          tempTabIndexPolygone={tempTabIndexPolygone}

          setMultiplePipe={setMultiplePipe}
          multiplePipe={multiplePipe}
          setUpdatedTabIndexPipe={setUpdatedTabIndexPipe}
          setTempTabIndexPipe={setTempTabIndexPipe}
          tempTabIndexPipe={tempTabIndexPipe}

          setMultipleSwitch={setMultipleSwitch}
          multipleSwitch={multipleSwitch}
          setUpdatedTabIndexSwitch={setUpdatedTabIndexSwitch}
          setTempTabIndexSwitch={setTempTabIndexSwitch}
          tempTabIndexSwitch={tempTabIndexSwitch}

          setMultipleCheckbox={setMultipleCheckbox}
          multipleCheckbox={multipleCheckbox}
          setUpdatedTabIndexCheckbox={setUpdatedTabIndexCheckbox}
          setTempTabIndexCheckbox={setTempTabIndexCheckbox}
          tempTabIndexCheckbox={tempTabIndexCheckbox}

          setMultipleRadio={setMultipleRadio}
          multipleRadio={multipleRadio}
          setUpdatedTabIndexRadio={setUpdatedTabIndexRadio}
          setTempTabIndexRadio={setTempTabIndexRadio}
          tempTabIndexRadio={tempTabIndexRadio}

          setMultipleSlider={setMultipleSlider}
          multipleSlider={multipleSlider}
          setUpdatedTabIndexSlider={setUpdatedTabIndexSlider}
          setTempTabIndexSlider={setTempTabIndexSlider}
          tempTabIndexSlider={tempTabIndexSlider}

          setMultipleLamp={setMultipleLamp}
          multipleLamp={multipleLamp}
          setUpdatedTabIndexLamp={setUpdatedTabIndexLamp}
          setTempTabIndexLamp={setTempTabIndexLamp}
          tempTabIndexLamp={tempTabIndexLamp}

          setMultiplePush={setMultiplePush}
          multiplePush={multiplePush}
          setUpdatedTabIndexPush={setUpdatedTabIndexPush}
          setTempTabIndexPush={setTempTabIndexPush}
          tempTabIndexPush={tempTabIndexPush}

          setMultipleLink={setMultipleLink}
          multipleLink={multipleLink}
          setUpdatedTabIndexLink={setUpdatedTabIndexLink}
          setTempTabIndexLink={setTempTabIndexLink}
          tempTabIndexLink={tempTabIndexLink}

          setMultipleClock={setMultipleClock}
          multipleClock={multipleClock}
          setUpdatedTabIndexClock={setUpdatedTabIndexClock}
          setTempTabIndexClock={setTempTabIndexClock}
          tempTabIndexClock={tempTabIndexClock}

          setMultipleText={setMultipleText}
          multipleText={multipleText}
          setUpdatedTabIndexText={setUpdatedTabIndexText}
          setTempTabIndexText={setTempTabIndexText}
          tempTabIndexText={tempTabIndexText}


        />

        {isHorizontalMove && (


          <ShowHorizontalMovementPopup

            tableData={tableData}
            setIsHorizontalMove={setIsHorizontalMove}
            setConditionValue={setConditionValue}
            setMoveValue={setMoveValue}
            setHorizontalMoveChannel={setHorizontalMoveChannel}
            conditionValue={conditionValue}
            moveValue={moveValue}
            currentDevice={currentDevice}
            activeTabIndex={activeTabIndex}
            tempImages={tempImages}
            selectedDevice={selectedDevice}
            clickedDeviceIndex={clickedDeviceIndex}
            setTempImages={setTempImages}
            setUpdatedImages={setUpdatedImages}
            tempTabIndexSquare={tempTabIndexSquare}
            setTempTabIndexSquare={setTempTabIndexSquare}
            setUpdatedTabIndexSquare={setUpdatedTabIndexSquare}
            multipleSquare={multipleSquare}
            setMultipleSquare={setMultipleSquare}
            horizontalMoveChannel={horizontalMoveChannel}
            tempTabIndexCircle={tempTabIndexCircle}
            setTempTabIndexCircle={setTempTabIndexCircle}
            setUpdatedTabIndexCircle={setUpdatedTabIndexCircle}
            multipleCircle={multipleCircle}
            setMultipleCircle={setMultipleCircle}
            tempTabIndexImages={tempTabIndexImages}
            setTempTabIndexImages={setTempTabIndexImages}
            setUpdatedTabIndexImages={setUpdatedTabIndexImages}
            multipleImages={multipleImages}
            setMultipleImages={setMultipleImages}

            tempTabIndexLines={tempTabIndexLines}
            setTempTabIndexLines={setTempTabIndexLines}
            setUpdatedTabIndexLines={setUpdatedTabIndexLines}
            multipleLines={multipleLines}
            setMultipleLines={setMultipleLines}
          />
        )}

        {isVerticalMove && (

          <ShowVerticalMovementPopup

            tableData={tableData}
            setIsVerticalMove={setIsVerticalMove}
            setConditionValue={setConditionValue}
            setMoveValue={setMoveValue}
            conditionValue={conditionValue}
            moveValue={moveValue}
            setVerticalMoveChannel={setVerticalMoveChannel}
            currentDevice={currentDevice}
            activeTabIndex={activeTabIndex}
            tempImages={tempImages}
            selectedDevice={selectedDevice}
            clickedDeviceIndex={clickedDeviceIndex}
            setTempImages={setTempImages}
            setUpdatedImages={setUpdatedImages}
            tempTabIndexSquare={tempTabIndexSquare}
            setTempTabIndexSquare={setTempTabIndexSquare}
            setUpdatedTabIndexSquare={setUpdatedTabIndexSquare}
            multipleSquare={multipleSquare}
            setMultipleSquare={setMultipleSquare}
            verticalMoveChannel={verticalMoveChannel}
            tempTabIndexCircle={tempTabIndexCircle}
            setTempTabIndexCircle={setTempTabIndexCircle}
            setUpdatedTabIndexCircle={setUpdatedTabIndexCircle}
            multipleCircle={multipleCircle}
            setMultipleCircle={setMultipleCircle}
            tempTabIndexImages={tempTabIndexImages}
            setTempTabIndexImages={setTempTabIndexImages}
            setUpdatedTabIndexImages={setUpdatedTabIndexImages}
            multipleImages={multipleImages}
            setMultipleImages={setMultipleImages}

            tempTabIndexLines={tempTabIndexLines}
            setTempTabIndexLines={setTempTabIndexLines}
            setUpdatedTabIndexLines={setUpdatedTabIndexLines}
            multipleLines={multipleLines}
            setMultipleLines={setMultipleLines}
          />
        )}

        {isLineStyle && (

          <LineStyle
            setIsLineStyle={setIsLineStyle}
            lineStyle={lineStyle}
            setLineStyle={setLineStyle}
            isSteppedLine={isSteppedLine}
            setIsSteppedLine={setIsSteppedLine}
            isCurveLine={isCurveLine}
            setIsCurveLine={setIsCurveLine}
            tempTabIndexLineChart={tempTabIndexLineChart}
            setTempTabIndexLineChart={setTempTabIndexLineChart}
            multipleLineCharts={multipleLineCharts}
            setMultipleLineCharts={setMultipleLineCharts}
            currentDevice={currentDevice}
            activeTabIndex={activeTabIndex}
            tempImages={tempImages}
            selectedDevice={selectedDevice}
            clickedDeviceIndex={clickedDeviceIndex}
            setTempImages={setTempImages}
            setUpdatedImages={setUpdatedImages}
            setUpdatedTabIndexLineChart={setUpdatedTabIndexLineChart}
          />
        )}

        {isYRange && (
          <YAxisRange
            setIsYRange={setIsYRange}
            yRange={yRange}
            tempTabIndexLineChart={tempTabIndexLineChart}
            setTempTabIndexLineChart={setTempTabIndexLineChart}
            multipleLineCharts={multipleLineCharts}
            setMultipleLineCharts={setMultipleLineCharts}
            currentDevice={currentDevice}
            activeTabIndex={activeTabIndex}
            tempImages={tempImages}
            selectedDevice={selectedDevice}
            clickedDeviceIndex={clickedDeviceIndex}
            setTempImages={setTempImages}
            setUpdatedImages={setUpdatedImages}
            setUpdatedTabIndexLineChart={setUpdatedTabIndexLineChart}
            setYRange={setYRange}
          />
        )}

        {isGraphInterval && (
          <GraphInterval
            setIsGraphInterval={setIsGraphInterval}
            yInterval={yInterval}
            setYInterval={setYInterval}
            xInterval={xInterval}
            setXInterval={setXInterval}
            tempTabIndexLineChart={tempTabIndexLineChart}
            setTempTabIndexLineChart={setTempTabIndexLineChart}
            multipleLineCharts={multipleLineCharts}
            setMultipleLineCharts={setMultipleLineCharts}
            currentDevice={currentDevice}
            activeTabIndex={activeTabIndex}
            tempImages={tempImages}
            selectedDevice={selectedDevice}
            clickedDeviceIndex={clickedDeviceIndex}
            setTempImages={setTempImages}
            setUpdatedImages={setUpdatedImages}
            setUpdatedTabIndexLineChart={setUpdatedTabIndexLineChart}


          />
        )}

        {isBlinkPopup && (
          <BlinkPopup
            tableData={tableData}
            setIsBlinkPopup={setIsBlinkPopup}
            blinkChannel={blinkChannel}
            setBlinkChannel={setBlinkChannel}
            blinkValue={blinkValue}
            setBlinkValue={setBlinkValue}
            blinkFrequency={blinkFrequency}
            setBlinkFrequency={setBlinkFrequency}
            blinkFunction={blinkFunction}
            setBlinkFunction={setBlinkFunction}
            currentDevice={currentDevice}
            activeTabIndex={activeTabIndex}
            tempImages={tempImages}
            selectedDevice={selectedDevice}
            clickedDeviceIndex={clickedDeviceIndex}
            setTempImages={setTempImages}
            setUpdatedImages={setUpdatedImages}
            tempTabIndexSquare={tempTabIndexSquare}
            setTempTabIndexSquare={setTempTabIndexSquare}
            setUpdatedTabIndexSquare={setUpdatedTabIndexSquare}
            multipleSquare={multipleSquare}
            setMultipleSquare={setMultipleSquare}
            multipleCircle={multipleCircle}
            tempTabIndexCircle={tempTabIndexCircle}
            setTempTabIndexCircle={setTempTabIndexCircle}
            setUpdatedTabIndexCircle={setUpdatedTabIndexCircle}
            setMultipleCircle={setMultipleCircle}
            multipleImages={multipleImages}
            tempTabIndexImages={tempTabIndexImages}
            setTempTabIndexImages={setTempTabIndexImages}
            setUpdatedTabIndexImages={setUpdatedTabIndexImages}
            setMultipleImages={setMultipleImages}
            multipleLines={multipleLines}
            tempTabIndexLines={tempTabIndexLines}
            setTempTabIndexLines={setTempTabIndexLines}
            setUpdatedTabIndexLines={setUpdatedTabIndexLines}
            setMultipleLines={setMultipleLines}
            multipleIO={multipleIO}
            tempTabIndexIO={tempTabIndexIO}
            setTempTabIndexIO={setTempTabIndexIO}
            setUpdatedTabIndexIO={setUpdatedTabIndexIO}
            setMultipleIO={setMultipleIO}

          />
        )}

      </div>
    </>
  );
};

export default NewPage;